export const episodeTranscripts = {
  "silicon-valley-101/6a13923cfe904f3873c51d2b": {
    "source_id": "silicon-valley-101",
    "episode_id": "6a13923cfe904f3873c51d2b",
    "title": "E238｜聊聊Harness时代AI-First的组织架构：从信任人到信任AI",
    "transcript_source": "local_asr_generated",
    "official_transcript_found": false,
    "segment_count": 481,
    "generated_at": "2026-06-02T05:56:15.886Z",
    "audio_sha256": "f6e786c18125aa134e91809d363124bb1b7d1563741bdc1da1e4ded24a12f124",
    "artifact_markdown": "data/episode-content/silicon-valley-101/6a13923cfe904f3873c51d2b/transcript-asr.md",
    "segments": [
      {
        "id": "asr_segment_0001",
        "start_ms": 0,
        "end_ms": 3760,
        "time_range": "00:00:00 - 00:00:03",
        "text": "哈喽,大家好,欢迎收听硅谷101,我是红军。"
      },
      {
        "id": "asr_segment_0002",
        "start_ms": 4400,
        "end_ms": 9260,
        "time_range": "00:00:04 - 00:00:09",
        "text": "过去三年,我们经历了大模型工程能力的三次概念上的进化。"
      },
      {
        "id": "asr_segment_0003",
        "start_ms": 9760,
        "end_ms": 15420,
        "time_range": "00:00:09 - 00:00:15",
        "text": "大家还记得在2023年,模型刚刚出来的时候,我们大家都在聊Prompt Engineering。"
      },
      {
        "id": "asr_segment_0004",
        "start_ms": 15940,
        "end_ms": 21480,
        "time_range": "00:00:15 - 00:00:21",
        "text": "它的核心是说要怎么样去写好一个提示词,让模型给出更好的答案。"
      },
      {
        "id": "asr_segment_0005",
        "start_ms": 22160,
        "end_ms": 25720,
        "time_range": "00:00:22 - 00:00:25",
        "text": "后来在2024年,焦点就变成了Context Engineering。"
      },
      {
        "id": "asr_segment_0006",
        "start_ms": 26300,
        "end_ms": 32460,
        "time_range": "00:00:26 - 00:00:32",
        "text": "它是说怎么给模型提供更完整的上架文,让它能够去理解更加复杂的任务。"
      },
      {
        "id": "asr_segment_0007",
        "start_ms": 33120,
        "end_ms": 39100,
        "time_range": "00:00:33 - 00:00:39",
        "text": "到2026年,一个新的词开始在硅谷流行起来了,叫做Harness Engineering。"
      },
      {
        "id": "asr_segment_0008",
        "start_ms": 39860,
        "end_ms": 47880,
        "time_range": "00:00:39 - 00:00:47",
        "text": "Harness,在英文里,它原本是指玩具,就是说套在马身上用来引导和约束马的那套装备。"
      },
      {
        "id": "asr_segment_0009",
        "start_ms": 48400,
        "end_ms": 53920,
        "time_range": "00:00:48 - 00:00:53",
        "text": "那现在它被用来形容一件事,就是你怎么样去围绕大模型搭建一套,"
      },
      {
        "id": "asr_segment_0010",
        "start_ms": 54180,
        "end_ms": 59940,
        "time_range": "00:00:54 - 00:00:59",
        "text": "能够让它在真实的世界中持续工作,自我修复,还能自我提升的一套系统。"
      },
      {
        "id": "asr_segment_0011",
        "start_ms": 61000,
        "end_ms": 70960,
        "time_range": "00:01:01 - 00:01:10",
        "text": "最近,CREO的CTO Peter,他在推特上写了一篇文章,叫做《为什么你的AI优先战略可能错了?》,引发了几百万的关注与讨论。"
      },
      {
        "id": "asr_segment_0012",
        "start_ms": 71520,
        "end_ms": 76440,
        "time_range": "00:01:11 - 00:01:16",
        "text": "所以他的核心结论是,大多数公司所谓的这种AI first都是假的。"
      },
      {
        "id": "asr_segment_0013",
        "start_ms": 76720,
        "end_ms": 86480,
        "time_range": "00:01:16 - 00:01:26",
        "text": "那真正的AI优先战略是重新设计整个公司的流程还有组织结构,本质上也是他们内部怎么样去Harness的过程。"
      },
      {
        "id": "asr_segment_0014",
        "start_ms": 86480,
        "end_ms": 97400,
        "time_range": "00:01:26 - 00:01:37",
        "text": "Peter之前是Meta-Lama基础模型团队的研究科学家,后来在苹果从事多模态模型的相关工作,所以他的工作语言是英文。"
      },
      {
        "id": "asr_segment_0015",
        "start_ms": 97820,
        "end_ms": 103280,
        "time_range": "00:01:37 - 00:01:43",
        "text": "如果本期内容的中英文夹杂过多啊,欢迎大家收看我们播客的字幕版。"
      },
      {
        "id": "asr_segment_0016",
        "start_ms": 103780,
        "end_ms": 120240,
        "time_range": "00:01:43 - 00:02:00",
        "text": "那也很难得,今天除了Peter,我们还把CREO的另外两位创始人,也是这个故事的亲历者,邀请到了我们的节目上,来聊一聊他们是怎么在AI快速进化的一年里,重新组织自己的组织架构,把信任人变成了信任AI。"
      },
      {
        "id": "asr_segment_0017",
        "start_ms": 121560,
        "end_ms": 125460,
        "time_range": "00:02:01 - 00:02:05",
        "text": "好,那首先我们请今天的三位嘉宾简单介绍一下自己。"
      },
      {
        "id": "asr_segment_0018",
        "start_ms": 125960,
        "end_ms": 128840,
        "time_range": "00:02:05 - 00:02:08",
        "text": "大家好,我是Peter,CREO的co-founder and CTO。"
      },
      {
        "id": "asr_segment_0019",
        "start_ms": 129160,
        "end_ms": 131940,
        "time_range": "00:02:09 - 00:02:11",
        "text": "大家好,我是CREO的CEO and co-founder,陈凯。"
      },
      {
        "id": "asr_segment_0020",
        "start_ms": 132280,
        "end_ms": 133760,
        "time_range": "00:02:12 - 00:02:13",
        "text": "大家好,我是Clark。"
      },
      {
        "id": "asr_segment_0021",
        "start_ms": 134200,
        "end_ms": 151720,
        "time_range": "00:02:14 - 00:02:31",
        "text": "我是CREO的co-founder,现在主要负责我们的go-to-market,之前是做了很多年的这个data scientist和machine learning engineer,现在在agent的这个领域里面跟凯还有Peter一起帮助用户更好的使用agent,然后达到AI first这样一个组织形态的目的。"
      },
      {
        "id": "asr_segment_0022",
        "start_ms": 152260,
        "end_ms": 158500,
        "time_range": "00:02:32 - 00:02:38",
        "text": "好的,欢迎三位。开始的时候我们就直接主题吧,就最近大家都在关注这个harness engineering。"
      },
      {
        "id": "asr_segment_0023",
        "start_ms": 159000,
        "end_ms": 162700,
        "time_range": "00:02:39 - 00:02:42",
        "text": "那Peter,你要不要跟我们介绍一下什么是harness的engineering?"
      },
      {
        "id": "asr_segment_0024",
        "start_ms": 162980,
        "end_ms": 173140,
        "time_range": "00:02:42 - 00:02:53",
        "text": "harness这个概念其实可以追溯到大模型刚开始的时候,很多人在聊prompt engineering,之后也变到contact engineering,到之后的harness。"
      },
      {
        "id": "asr_segment_0025",
        "start_ms": 173140,
        "end_ms": 189060,
        "time_range": "00:02:53 - 00:03:09",
        "text": "整个harness过程不仅仅是对于LM本身的harness,还包括围绕的整个大模型,包括它的基建tooling的使用,包括安全的security的保证,整个的这样一个improve的过程,我们把它叫做harness。"
      },
      {
        "id": "asr_segment_0026",
        "start_ms": 189460,
        "end_ms": 195980,
        "time_range": "00:03:09 - 00:03:15",
        "text": "可不可以跟听众解释一下,这三次进化它是怎么发生的,然后每一步它最重要的是什么?"
      },
      {
        "id": "asr_segment_0027",
        "start_ms": 196340,
        "end_ms": 205420,
        "time_range": "00:03:16 - 00:03:25",
        "text": "对,我先说一下prompt engineering和contact engineering,更多的是focus在怎么和LM这个大模型本身进行交互。"
      },
      {
        "id": "asr_segment_0028",
        "start_ms": 205880,
        "end_ms": 209020,
        "time_range": "00:03:25 - 00:03:29",
        "text": "就是我怎么优化它的contacts,怎么优化它的prompt。"
      },
      {
        "id": "asr_segment_0029",
        "start_ms": 209520,
        "end_ms": 220460,
        "time_range": "00:03:29 - 00:03:40",
        "text": "从这个角度上来讲,它的scope要比我们现在讲的harness要小得多,而且从静态和动态的角度上来讲,prompt engineering和contact engineering相对来说是一个静态的事情。"
      },
      {
        "id": "asr_segment_0030",
        "start_ms": 220460,
        "end_ms": 227160,
        "time_range": "00:03:40 - 00:03:47",
        "text": "因为你优化的是一个大模型,你优化的任务可能也是一个相对来说比较vertical的任务。"
      },
      {
        "id": "asr_segment_0031",
        "start_ms": 227620,
        "end_ms": 234700,
        "time_range": "00:03:47 - 00:03:54",
        "text": "但是对于harness来讲,harness是一个系统的harness,而且对我们来说我们是在harness是一个general的系统。"
      },
      {
        "id": "asr_segment_0032",
        "start_ms": 235060,
        "end_ms": 247920,
        "time_range": "00:03:55 - 00:04:07",
        "text": "所以从scope上来讲会比prompt和contact engineering要大很多,因为这涉及到tooling的使用,涉及到你的sandbox的架构设计和你的host service之间是怎么进行交互的,怎么样的交互能够安全。"
      },
      {
        "id": "asr_segment_0033",
        "start_ms": 248040,
        "end_ms": 253720,
        "time_range": "00:04:08 - 00:04:13",
        "text": "你的sandbox在启动的时间是多少,你的latency是多少,都是harness的一个部分。"
      },
      {
        "id": "asr_segment_0034",
        "start_ms": 254100,
        "end_ms": 265780,
        "time_range": "00:04:14 - 00:04:25",
        "text": "我可不可以理解成harness的工程能力在决定你怎么把一个大模型炸出它的最佳使用上限,它可以理解成是AI的一种工程能力。"
      },
      {
        "id": "asr_segment_0035",
        "start_ms": 266140,
        "end_ms": 275780,
        "time_range": "00:04:26 - 00:04:35",
        "text": "我先举一个例子,我记得凯你之前是在融资的一个新闻稿里面,其实你有提到一个agent他可以一夜之间干掉三个人这种做SEO的工作流。"
      },
      {
        "id": "asr_segment_0036",
        "start_ms": 276120,
        "end_ms": 281060,
        "time_range": "00:04:36 - 00:04:41",
        "text": "同时呢还有一个content的pipeline,他跑了两天,然后才有人发现全是垃圾。"
      },
      {
        "id": "asr_segment_0037",
        "start_ms": 281480,
        "end_ms": 286600,
        "time_range": "00:04:41 - 00:04:46",
        "text": "这两者之间的巨大的区别就是一个非常好的表现跟一个非常差的表现。"
      },
      {
        "id": "asr_segment_0038",
        "start_ms": 287000,
        "end_ms": 292620,
        "time_range": "00:04:47 - 00:04:52",
        "text": "我可不可以理解成从本质上说一个就是harness的胜利,一个就是harness的失败。"
      },
      {
        "id": "asr_segment_0039",
        "start_ms": 293060,
        "end_ms": 297800,
        "time_range": "00:04:53 - 00:04:57",
        "text": "对,刚才提到了两种状态嘛,一种是你效果好,一种是效果不好。"
      },
      {
        "id": "asr_segment_0040",
        "start_ms": 298280,
        "end_ms": 302580,
        "time_range": "00:04:58 - 00:05:02",
        "text": "但是我觉得这个是完全就印证了为什么我们需要harness。"
      },
      {
        "id": "asr_segment_0041",
        "start_ms": 302860,
        "end_ms": 306740,
        "time_range": "00:05:02 - 00:05:06",
        "text": "因为harness的本质就是在于我们怎么能够持续提升一个系统。"
      },
      {
        "id": "asr_segment_0042",
        "start_ms": 307140,
        "end_ms": 312680,
        "time_range": "00:05:07 - 00:05:12",
        "text": "当你这个系统产生的效果不好的时候,你这个系统是需要人的feedback去提升呢?"
      },
      {
        "id": "asr_segment_0043",
        "start_ms": 312920,
        "end_ms": 316020,
        "time_range": "00:05:12 - 00:05:16",
        "text": "还是这个系统本身自己能够self healing,self improvement?"
      },
      {
        "id": "asr_segment_0044",
        "start_ms": 316420,
        "end_ms": 318280,
        "time_range": "00:05:16 - 00:05:18",
        "text": "这个正好就是harness的核心。"
      },
      {
        "id": "asr_segment_0045",
        "start_ms": 318480,
        "end_ms": 322500,
        "time_range": "00:05:18 - 00:05:22",
        "text": "因为通常来讲我们也有很多用户在我们的平台上产生agent。"
      },
      {
        "id": "asr_segment_0046",
        "start_ms": 322780,
        "end_ms": 327040,
        "time_range": "00:05:22 - 00:05:27",
        "text": "但是这个agent不是说one shot就能达到一个完全优化的状态。"
      },
      {
        "id": "asr_segment_0047",
        "start_ms": 327440,
        "end_ms": 329400,
        "time_range": "00:05:27 - 00:05:29",
        "text": "用户怎么去follow up这个agent?"
      },
      {
        "id": "asr_segment_0048",
        "start_ms": 329600,
        "end_ms": 331960,
        "time_range": "00:05:29 - 00:05:31",
        "text": "我们的系统怎么能够self improve这个agent?"
      },
      {
        "id": "asr_segment_0049",
        "start_ms": 332420,
        "end_ms": 334060,
        "time_range": "00:05:32 - 00:05:34",
        "text": "也是整个harness的核心。"
      },
      {
        "id": "asr_segment_0050",
        "start_ms": 334640,
        "end_ms": 340340,
        "time_range": "00:05:34 - 00:05:40",
        "text": "harness很重要的一件事情就是怎么能够让agent在inference阶段scaling。"
      },
      {
        "id": "asr_segment_0051",
        "start_ms": 340640,
        "end_ms": 344960,
        "time_range": "00:05:40 - 00:05:44",
        "text": "包括你怎么能够把更多的context提供能给他,更多的tooling给他,"
      },
      {
        "id": "asr_segment_0052",
        "start_ms": 344960,
        "end_ms": 349640,
        "time_range": "00:05:44 - 00:05:49",
        "text": "让他思考更长的时间,完成一个任务,用一个更长的时间。"
      },
      {
        "id": "asr_segment_0053",
        "start_ms": 349720,
        "end_ms": 352500,
        "time_range": "00:05:49 - 00:05:52",
        "text": "我觉得这都是在inference阶段的一个scaling。"
      },
      {
        "id": "asr_segment_0054",
        "start_ms": 352500,
        "end_ms": 358660,
        "time_range": "00:05:52 - 00:05:58",
        "text": "所以在inference阶段的scaling,因为他工作时间长,tooling使用的数量多,他的context多。"
      },
      {
        "id": "asr_segment_0055",
        "start_ms": 359020,
        "end_ms": 368040,
        "time_range": "00:05:59 - 00:06:08",
        "text": "所以你harness如果做得不好的话,就很容易产生hallucination,或者你context overflow,你的模型的能力会degregate。"
      },
      {
        "id": "asr_segment_0056",
        "start_ms": 368340,
        "end_ms": 376400,
        "time_range": "00:06:08 - 00:06:16",
        "text": "所以在这个过程之中,怎么把这个harness做好,其实是一件非常复杂,而且需要一些经验的事情。"
      },
      {
        "id": "asr_segment_0057",
        "start_ms": 376820,
        "end_ms": 386260,
        "time_range": "00:06:16 - 00:06:26",
        "text": "对,换句话说,就是harness它是一个新概念,但是它所谓的新呢,其实是把这种传统软件的东西放到了agent的应用上。"
      },
      {
        "id": "asr_segment_0058",
        "start_ms": 386500,
        "end_ms": 394480,
        "time_range": "00:06:26 - 00:06:34",
        "text": "所以大家怎么去看这个harness里面,它有哪些是我们这个时代的新的东西,传统工程没有的。"
      },
      {
        "id": "asr_segment_0059",
        "start_ms": 394960,
        "end_ms": 399100,
        "time_range": "00:06:34 - 00:06:39",
        "text": "因为大多数业务的人,他可能都是从能力层面去理解一个软件。"
      },
      {
        "id": "asr_segment_0060",
        "start_ms": 399440,
        "end_ms": 404860,
        "time_range": "00:06:39 - 00:06:44",
        "text": "就像很多人从传统的角度来讲,他不理解就是说,其实一个很简单的功能,可能都需要开发团队。"
      },
      {
        "id": "asr_segment_0061",
        "start_ms": 404980,
        "end_ms": 408260,
        "time_range": "00:06:44 - 00:06:48",
        "text": "在之前的情况下,就可能要做两到三个月才能去实现。"
      },
      {
        "id": "asr_segment_0062",
        "start_ms": 408560,
        "end_ms": 414120,
        "time_range": "00:06:48 - 00:06:54",
        "text": "很多业务的人经常会说的事情是,我觉得这个功能很简单,为什么你这个产品就是一直解决不了我这个问题呢?"
      },
      {
        "id": "asr_segment_0063",
        "start_ms": 414320,
        "end_ms": 417980,
        "time_range": "00:06:54 - 00:06:57",
        "text": "那其实是因为后面有太多的工程化的问题牵扯在那边。"
      },
      {
        "id": "asr_segment_0064",
        "start_ms": 418320,
        "end_ms": 420200,
        "time_range": "00:06:58 - 00:07:00",
        "text": "其实这个对于agent来讲也是一样的。"
      },
      {
        "id": "asr_segment_0065",
        "start_ms": 420460,
        "end_ms": 424400,
        "time_range": "00:07:00 - 00:07:04",
        "text": "很多人会觉得LM的能力提升了,但为什么他做不到我想要做的事情?"
      },
      {
        "id": "asr_segment_0066",
        "start_ms": 424520,
        "end_ms": 427080,
        "time_range": "00:07:04 - 00:07:07",
        "text": "那其实是因为还有很多工程化的问题需要一起被解决。"
      },
      {
        "id": "asr_segment_0067",
        "start_ms": 427500,
        "end_ms": 430800,
        "time_range": "00:07:07 - 00:07:10",
        "text": "那这个其实也是我们去做harness的一个原因嘛。"
      },
      {
        "id": "asr_segment_0068",
        "start_ms": 431060,
        "end_ms": 438460,
        "time_range": "00:07:11 - 00:07:18",
        "text": "你觉得今天我们市场在讨论harness的这个部分中,有哪些是大家的共识,有哪些是非共识?"
      },
      {
        "id": "asr_segment_0069",
        "start_ms": 438760,
        "end_ms": 442960,
        "time_range": "00:07:18 - 00:07:22",
        "text": "因为我觉得不同的群体对harness的认知可能不一样。"
      },
      {
        "id": "asr_segment_0070",
        "start_ms": 443400,
        "end_ms": 447680,
        "time_range": "00:07:23 - 00:07:27",
        "text": "我听到的很多看法,通常来讲对待harness是一个静态的过程。"
      },
      {
        "id": "asr_segment_0071",
        "start_ms": 448260,
        "end_ms": 452900,
        "time_range": "00:07:28 - 00:07:32",
        "text": "我怎么能够develop it out系统,去把LM的优势更大的发挥出来?"
      },
      {
        "id": "asr_segment_0072",
        "start_ms": 453240,
        "end_ms": 457220,
        "time_range": "00:07:33 - 00:07:37",
        "text": "而对于我们来讲,我们认知中的harness就是一个动态的过程。"
      },
      {
        "id": "asr_segment_0073",
        "start_ms": 457220,
        "end_ms": 460880,
        "time_range": "00:07:37 - 00:07:40",
        "text": "你这个系统怎么能够从一个静态的状态真的活起来?"
      },
      {
        "id": "asr_segment_0074",
        "start_ms": 461060,
        "end_ms": 470600,
        "time_range": "00:07:41 - 00:07:50",
        "text": "能够self-improve,能够不停地adapt新的signal,不管是marketing的signal,还是产品本身的signal,还是用户的signal,能够让它不停地迅速地迭代。"
      },
      {
        "id": "asr_segment_0075",
        "start_ms": 470760,
        "end_ms": 473220,
        "time_range": "00:07:50 - 00:07:53",
        "text": "我觉得这个是可能很多人还没有意识到的一点。"
      },
      {
        "id": "asr_segment_0076",
        "start_ms": 473720,
        "end_ms": 477780,
        "time_range": "00:07:53 - 00:07:57",
        "text": "然后这个迭代也是以AI为主导的,而不是人为主导的。"
      },
      {
        "id": "asr_segment_0077",
        "start_ms": 478260,
        "end_ms": 480600,
        "time_range": "00:07:58 - 00:08:00",
        "text": "对,也是以AI为主导的迭代。"
      },
      {
        "id": "asr_segment_0078",
        "start_ms": 480760,
        "end_ms": 489600,
        "time_range": "00:08:00 - 00:08:09",
        "text": "但是人所需要做的事情就是怎么把各种各样的signal fit给AI,不管是marketing的signal,还是产品的signal,还是本身infrastructure的signal。"
      },
      {
        "id": "asr_segment_0079",
        "start_ms": 489900,
        "end_ms": 500960,
        "time_range": "00:08:09 - 00:08:20",
        "text": "对,我注意到最近啊,你有一篇Twitter的帖子非常火,然后其实是讲你们是怎么一家25个人的公司,然后99%的代码都是AI来写的。"
      },
      {
        "id": "asr_segment_0080",
        "start_ms": 500960,
        "end_ms": 510580,
        "time_range": "00:08:20 - 00:08:30",
        "text": "基本上你早上10点写了一个功能,中午就进行了A-B test,然后下午3点的时候呢,就根据数据的反馈把它砍掉了一份功能。"
      },
      {
        "id": "asr_segment_0081",
        "start_ms": 510900,
        "end_ms": 514580,
        "time_range": "00:08:30 - 00:08:34",
        "text": "5点又重写了更好的一个版本,这是一天的时间。"
      },
      {
        "id": "asr_segment_0082",
        "start_ms": 515040,
        "end_ms": 520200,
        "time_range": "00:08:35 - 00:08:40",
        "text": "但是这种工作的节奏在传统的开发产品的过程中,它是需要6周的。"
      },
      {
        "id": "asr_segment_0083",
        "start_ms": 520520,
        "end_ms": 527680,
        "time_range": "00:08:40 - 00:08:47",
        "text": "你的这个帖子在Twitter上非常的火,到现在为止,我昨天还去看了一眼,有187万的Twitter的流量。"
      },
      {
        "id": "asr_segment_0084",
        "start_ms": 527800,
        "end_ms": 540320,
        "time_range": "00:08:47 - 00:09:00",
        "text": "同时下面大家也有很多的共鸣,但仔细看下来,其实我觉得你就是在讲CREO在整个工作流程中用Harness去做的,也算是你自己独立探讨出来的一条Harness的方式。"
      },
      {
        "id": "asr_segment_0085",
        "start_ms": 540620,
        "end_ms": 545680,
        "time_range": "00:09:00 - 00:09:05",
        "text": "对,我觉得这个就牵扯到Harness的一个具体细分的层级。"
      },
      {
        "id": "asr_segment_0086",
        "start_ms": 546060,
        "end_ms": 549860,
        "time_range": "00:09:06 - 00:09:09",
        "text": "在我们CREO来看,Harness分成两个主要的部分。"
      },
      {
        "id": "asr_segment_0087",
        "start_ms": 549860,
        "end_ms": 560260,
        "time_range": "00:09:09 - 00:09:20",
        "text": "一个是对于CREO本身Agent系统的Harness,另外一个是对于用户使用CREO的时候在构建自己的Agent的过程中,怎么Harness自己的Agent。"
      },
      {
        "id": "asr_segment_0088",
        "start_ms": 560580,
        "end_ms": 571660,
        "time_range": "00:09:20 - 00:09:31",
        "text": "在之前的话,我们传统的开发过程中可能需要两三个月的时间来迭代一个feature,但是在Agent这个情况之下,很多东西都是AI辅助的coding。"
      },
      {
        "id": "asr_segment_0089",
        "start_ms": 572060,
        "end_ms": 582140,
        "time_range": "00:09:32 - 00:09:42",
        "text": "本身implement的这个feature可能只需要一两个小时的时间,所以在这个过程之中,如果我们再花很长的时间去design和很长的时间去testing,就不是很make sense。"
      },
      {
        "id": "asr_segment_0090",
        "start_ms": 582140,
        "end_ms": 592660,
        "time_range": "00:09:42 - 00:09:52",
        "text": "所以我们怎么把design,planning的阶段和testing的阶段include到整个的这个Harness过程中,对这个公司能不能真正转型成为一个AI first公司是非常critical的。"
      },
      {
        "id": "asr_segment_0091",
        "start_ms": 592960,
        "end_ms": 600000,
        "time_range": "00:09:52 - 00:10:00",
        "text": "对,我想先跟大家表达一个观点,我们如果想要做到所谓的AI first或者AI native这样的一个状态,"
      },
      {
        "id": "asr_segment_0092",
        "start_ms": 600000,
        "end_ms": 609200,
        "time_range": "00:10:00 - 00:10:09",
        "text": "那它并不是在现有的流程上面去使用AI的工具,而是要围绕AI的能力去重新的构建你的工作流程和组织形态。"
      },
      {
        "id": "asr_segment_0093",
        "start_ms": 609520,
        "end_ms": 622060,
        "time_range": "00:10:09 - 00:10:22",
        "text": "所以这个是Peter刚刚所描述的,因为其实我们在之前的很长一段时间里面,其实每一个工程师他都在用AI写代码,每一个产品经理都在用AI写PRD,每一个设计师都在用AI做图。"
      },
      {
        "id": "asr_segment_0094",
        "start_ms": 622220,
        "end_ms": 635340,
        "time_range": "00:10:22 - 00:10:35",
        "text": "但其实这样并没有增加我们的效率,反而是导致每一个人的工作的进度和节奏不一样之后,我们的alignment的成本变得非常之高,因为我们本身是一个全部都是remote办公的状态。"
      },
      {
        "id": "asr_segment_0095",
        "start_ms": 635780,
        "end_ms": 646080,
        "time_range": "00:10:35 - 00:10:46",
        "text": "所以在这样的一个机制下,我们要去重新的想我们到底怎么样能够让AI在我们整个公司的运营的过程中能够真正的自动化跑起来。"
      },
      {
        "id": "asr_segment_0096",
        "start_ms": 646240,
        "end_ms": 661040,
        "time_range": "00:10:46 - 00:11:01",
        "text": "所以才Peter设计了一套新的开发流程和我们新的产品的架构重构,才有了今天Peter所写的这篇文章里面所讲的这个self-healing的自我修复的agent harness或者engineer harness是一个什么样的形态。"
      },
      {
        "id": "asr_segment_0097",
        "start_ms": 661420,
        "end_ms": 673680,
        "time_range": "00:11:01 - 00:11:13",
        "text": "可不可以举一个例子,因为你在说重塑开发流程跟组织架构,你们开始用AI自己去写agent的过程中,包括你们在重塑你们整个的组织架构的过程中。"
      },
      {
        "id": "asr_segment_0098",
        "start_ms": 673840,
        "end_ms": 683160,
        "time_range": "00:11:13 - 00:11:23",
        "text": "你们觉得哪些方向发生了变化?瓶颈在哪些方向?哪些方向跟你们在预期的过程中它是不一样的?"
      },
      {
        "id": "asr_segment_0099",
        "start_ms": 683540,
        "end_ms": 691220,
        "time_range": "00:11:23 - 00:11:31",
        "text": "对,我觉得在我们整个推进Harness和推进AI First的过程之中,首先需要解决的就是人的问题。"
      },
      {
        "id": "asr_segment_0100",
        "start_ms": 691660,
        "end_ms": 693960,
        "time_range": "00:11:31 - 00:11:33",
        "text": "大家能不能够接受这个新的工作方式。"
      },
      {
        "id": "asr_segment_0101",
        "start_ms": 694300,
        "end_ms": 700380,
        "time_range": "00:11:34 - 00:11:40",
        "text": "所以我们也花了很长的时间去align大家的mindset,我觉得这个mindset的alignment是最重要的。"
      },
      {
        "id": "asr_segment_0102",
        "start_ms": 700720,
        "end_ms": 706620,
        "time_range": "00:11:40 - 00:11:46",
        "text": "之前的话可能我们需要做这样一个转型,需要很长的时间,因为人需要去搭建这个系统。"
      },
      {
        "id": "asr_segment_0103",
        "start_ms": 707000,
        "end_ms": 714920,
        "time_range": "00:11:47 - 00:11:54",
        "text": "通常比如说一个architecture,一个engineer,他需要several months的时间去demonstrate我的这个新的工作方式是比之前的更好的。"
      },
      {
        "id": "asr_segment_0104",
        "start_ms": 715320,
        "end_ms": 717900,
        "time_range": "00:11:55 - 00:11:57",
        "text": "但这个转型的cost就相对来说非常的大。"
      },
      {
        "id": "asr_segment_0105",
        "start_ms": 718320,
        "end_ms": 725900,
        "time_range": "00:11:58 - 00:12:05",
        "text": "但是在AI辅助的情况之下,我们在demonstrate整个这个新的工作方式的过程中,就比以前会快很多。"
      },
      {
        "id": "asr_segment_0106",
        "start_ms": 726040,
        "end_ms": 734100,
        "time_range": "00:12:06 - 00:12:14",
        "text": "可能我们只需要一两周的时间把整个系统进行重构,包括从前端、后端、architecture、infrastructure都进行重构。"
      },
      {
        "id": "asr_segment_0107",
        "start_ms": 734220,
        "end_ms": 738500,
        "time_range": "00:12:14 - 00:12:18",
        "text": "然后给大家demonstrate这样一个新的过程,它work起来是更efficient的。"
      },
      {
        "id": "asr_segment_0108",
        "start_ms": 738860,
        "end_ms": 747160,
        "time_range": "00:12:18 - 00:12:27",
        "text": "不管是deployment的频率,deployment reliability和最后的效果上来讲,都能够比之前的工作方式有一个很大的提升。"
      },
      {
        "id": "asr_segment_0109",
        "start_ms": 747160,
        "end_ms": 751180,
        "time_range": "00:12:27 - 00:12:31",
        "text": "这样的话,我们可以在很短的时间内对大家的mindset进行一个align。"
      },
      {
        "id": "asr_segment_0110",
        "start_ms": 751540,
        "end_ms": 758620,
        "time_range": "00:12:31 - 00:12:38",
        "text": "之后的话,大家onboard到这个工作方式的过程之中的话,就能够更快速地融入到整个的开发过程。"
      },
      {
        "id": "asr_segment_0111",
        "start_ms": 758960,
        "end_ms": 768340,
        "time_range": "00:12:38 - 00:12:48",
        "text": "对对对,其实harness本身其实它更多是在于Beau的一个系统真的能够让Peter刚才说的这个所谓的AI first这样子的一个组织结构能够高效地运转。"
      },
      {
        "id": "asr_segment_0112",
        "start_ms": 768660,
        "end_ms": 776720,
        "time_range": "00:12:48 - 00:12:56",
        "text": "这个其实非常重要,为什么因为很多的组织上的人,他的思维会很难去改变,他会觉得说我可以用AI来提升我的效率。"
      },
      {
        "id": "asr_segment_0113",
        "start_ms": 776720,
        "end_ms": 784280,
        "time_range": "00:12:56 - 00:13:04",
        "text": "但是AI first要求是说,你让AI来drive你的整一个公司的方向,还有可能你每天工作的方式都是由AI来drive的。"
      },
      {
        "id": "asr_segment_0114",
        "start_ms": 784480,
        "end_ms": 785600,
        "time_range": "00:13:04 - 00:13:05",
        "text": "这是完全不一样的概念。"
      },
      {
        "id": "asr_segment_0115",
        "start_ms": 785720,
        "end_ms": 788300,
        "time_range": "00:13:05 - 00:13:08",
        "text": "举个例子,是每次AI给你们布置任务吗?"
      },
      {
        "id": "asr_segment_0116",
        "start_ms": 788400,
        "end_ms": 806720,
        "time_range": "00:13:08 - 00:13:26",
        "text": "对对对,其实就说,对原来可能大家都是觉得就说,还是人去提出一个概念,然后由AI来帮助人去提升效率,但这个东西可能因为人如果还是这个工具的使用者,那他的效率提升可能有一个所谓的效率的倍数的上限,可能最多就10倍,因为人最多每天可能就工作24小时嘛。"
      },
      {
        "id": "asr_segment_0117",
        "start_ms": 806960,
        "end_ms": 817680,
        "time_range": "00:13:26 - 00:13:37",
        "text": "但是如果说你真的希望AI能够给比如说我们工作的效率去提升100倍1000倍,你不能还是说是你是那个工具的使用者,而是AI应该是所有生产力的主导。"
      },
      {
        "id": "asr_segment_0118",
        "start_ms": 817680,
        "end_ms": 834440,
        "time_range": "00:13:37 - 00:13:54",
        "text": "因为人的角色就会发生变化,更多是在于我怎么去看最后的结果的是否是好的,或者说我怎么去review这个结果的好坏,还有包括我在这个系统里面,我并不是那个实际的工作者,那么如果在这样的角度下,我应该以怎样的一个方式去跟这个系统配合起来。"
      },
      {
        "id": "asr_segment_0119",
        "start_ms": 834720,
        "end_ms": 841240,
        "time_range": "00:13:54 - 00:14:01",
        "text": "那这个其实我觉得是很多的企业他在做转型,要么就是他没有意识到的点,或者说他很难去做到的一个事情。"
      },
      {
        "id": "asr_segment_0120",
        "start_ms": 841460,
        "end_ms": 871360,
        "time_range": "00:14:01 - 00:14:31",
        "text": "能不能举一个例子,你们的系统怎么跟人配合去工作,比如说是系统给人发任务,因为我觉得传统的团队啊,就大家在开发产品的时候,可能很大的一个痛点就是说我团队之间要对齐,然后我要把信息同步到每一个人,任何一个人他可能miss掉了一个信息点,那他在产品做开发的时候,他可能就不知道我们上一版的更新是什么,现在是不是所有的这些工作都可以交给AI,或者在这个流程中他就可以自动去做了。"
      },
      {
        "id": "asr_segment_0121",
        "start_ms": 871460,
        "end_ms": 893720,
        "time_range": "00:14:31 - 00:14:53",
        "text": "对,我觉得这里面核心的一个点还是信任的问题,因为很多时候就人因为对这个系统他没有信任,所以说刚才会有像您说对齐的成本就会非常高,像Clarke这边的GoToMarket这个team和比如说Peter这个Engineer这个team,他们两个团队怎么配合起来,原来的话他们需要互相的沟通,互相达成共识,对齐之后那才能事情往前推进嘛。"
      },
      {
        "id": "asr_segment_0122",
        "start_ms": 893760,
        "end_ms": 917620,
        "time_range": "00:14:53 - 00:15:17",
        "text": "但现在如果是AI first这个组结构的话,他们其实没有对齐的所谓的过程,而更多的是在于这个对齐是由AI来主导的,比如说告诉我们的marketing team说,今天我们开发团队Engineer要发布哪些功能,那这些功能到底是怎样的一个结构,那marketing就不用再去跟Engineer交流说,你明天要发什么功能,后天要发什么功能,那这样的话它中间的对齐成本就会降低嘛。"
      },
      {
        "id": "asr_segment_0123",
        "start_ms": 917760,
        "end_ms": 924620,
        "time_range": "00:15:17 - 00:15:24",
        "text": "AI怎么知道Peter的Engineering团队明天能把所有的工作做完,这个就是Peter可以说一下啊。"
      },
      {
        "id": "asr_segment_0124",
        "start_ms": 924820,
        "end_ms": 936240,
        "time_range": "00:15:24 - 00:15:36",
        "text": "对,我觉得在整个的这个过程,不管是叫harness还是AI主导的工作流过程中,主要大家体会到的improvement就是整个开发速度和迭代的提升。"
      },
      {
        "id": "asr_segment_0125",
        "start_ms": 936720,
        "end_ms": 943620,
        "time_range": "00:15:36 - 00:15:43",
        "text": "通常来讲implement一个feature或者deploy一个新的产品需要很长的周期,所以大家需要详细的讨论。"
      },
      {
        "id": "asr_segment_0126",
        "start_ms": 943760,
        "end_ms": 962440,
        "time_range": "00:15:43 - 00:16:02",
        "text": "但是我觉得在AI的mindset之下,因为它迭代一个产品的速度是很高的,那在这个过程之中,我们其实更侧重的是,OK这个新的feature能不能够带来产品的topline matrix的提升,或者我新的这个feature能不能有真的用户使用的数据。"
      },
      {
        "id": "asr_segment_0127",
        "start_ms": 962760,
        "end_ms": 979160,
        "time_range": "00:16:02 - 00:16:19",
        "text": "所以在这个过程中,我们更核心的focus的点是怎么把整个的数据链搭建起来,我们把这个链条搭建起来之后,都是agent通过这些数据来决定,OK这个feature到底是不是有用的,我们到底要不要rule out这个feature或者fallback这个feature。"
      },
      {
        "id": "asr_segment_0128",
        "start_ms": 979640,
        "end_ms": 999820,
        "time_range": "00:16:19 - 00:16:39",
        "text": "也就是说工程师写完代码以后,不需要手动的跟AI,比如说有一个什么工程管理的界面说我写完了,这是传统的软件跟公司内部系统同步的一种方式,然后现在说AI它就可以自动的根据你的整个的代码质量,你的进程去做出一个它的判断。"
      },
      {
        "id": "asr_segment_0129",
        "start_ms": 999820,
        "end_ms": 1026900,
        "time_range": "00:16:39 - 00:17:06",
        "text": "对,这个在传统的engineer中也有,我们叫CICD process,只不过在传统的CICD process的很多都是root-based的,或者一些unit testing driven的,但是在AI这个情况之下,我们可以有很多AI driven的testing,不管是integration test还是unit test,比如现在大家比较常用的像play write,是可以做AI driven的fully-entended testing,这样可以保证我们shipped代码中是没有明显的可以break这个产品的bug。"
      },
      {
        "id": "asr_segment_0130",
        "start_ms": 1027220,
        "end_ms": 1042000,
        "time_range": "00:17:07 - 00:17:22",
        "text": "所以在这个过程中,很多AI driven的testing是非常重要的,包括你代码shipped之后,在这个log中有没有error,有没有incidence,都是通过这些signal能够feedback给AI来看整个这个代码的质量是什么样子的。"
      },
      {
        "id": "asr_segment_0131",
        "start_ms": 1042480,
        "end_ms": 1057060,
        "time_range": "00:17:22 - 00:17:37",
        "text": "对,Clark,比如说你要在做市场营销的时候啊,就是你知道代码团队已经写完了,但是呢,我觉得很多时候大家一个产品要传递的核心的理念是什么,包括你要跟这个市场传递的关键信息是什么。"
      },
      {
        "id": "asr_segment_0132",
        "start_ms": 1057220,
        "end_ms": 1068620,
        "time_range": "00:17:37 - 00:17:48",
        "text": "它很多时候是需要一个产品的灵魂人物,不管是CEO还是CTO还是产品经理,他是会有一些沟通跟关键信息的梳理的,这个是AI能做的吗?"
      },
      {
        "id": "asr_segment_0133",
        "start_ms": 1068900,
        "end_ms": 1079480,
        "time_range": "00:17:48 - 00:17:59",
        "text": "是的,您这个问题问的非常的一针见血啊,其实我们现在也花了很多时间思考这个问题,因为我们就实行这套新的开发机制已经有几个月时间。"
      },
      {
        "id": "asr_segment_0134",
        "start_ms": 1080020,
        "end_ms": 1093000,
        "time_range": "00:18:00 - 00:18:13",
        "text": "我自己的一个体会呢,就是说现在我们确实不用跟engineer过多的沟通说你要做什么feature,然后你什么时候能deliver,因为feature现在的数量已经远远超过我们能够去卖它的这个能力了。"
      },
      {
        "id": "asr_segment_0135",
        "start_ms": 1093360,
        "end_ms": 1098420,
        "time_range": "00:18:13 - 00:18:18",
        "text": "这个是我最大的体会就是我们现在开发的速度是远远超过于市场这边的进度的。"
      },
      {
        "id": "asr_segment_0136",
        "start_ms": 1098720,
        "end_ms": 1108800,
        "time_range": "00:18:18 - 00:18:28",
        "text": "但这样有一个好处就是我们不再去用讨论说,今天你这个公司的product roadmap是什么,而我们只需要讨论的是现在市场的需求在哪里。"
      },
      {
        "id": "asr_segment_0137",
        "start_ms": 1109200,
        "end_ms": 1119360,
        "time_range": "00:18:29 - 00:18:39",
        "text": "我们就好像有个菜篮子一样,或者说像机器猫的万能的那个宝箱一样,如果今天说市场的需求是一个苹果,我们就从我们的这个篮子里面挑一个苹果去卖。"
      },
      {
        "id": "asr_segment_0138",
        "start_ms": 1119720,
        "end_ms": 1123040,
        "time_range": "00:18:39 - 00:18:43",
        "text": "如果今天市场的需求是一个香蕉,我们就可以挑一个香蕉去卖。"
      },
      {
        "id": "asr_segment_0139",
        "start_ms": 1123480,
        "end_ms": 1134700,
        "time_range": "00:18:43 - 00:18:54",
        "text": "这个反而是大大降低了我们对其说,今天好像市场反应是这样的,我们要去重新思考我们要做什么样的产品,这个其实是比国区要省时和省力很多的。"
      },
      {
        "id": "asr_segment_0140",
        "start_ms": 1134960,
        "end_ms": 1149240,
        "time_range": "00:18:54 - 00:19:09",
        "text": "我理解了,就相当于其实你们的开发能力是远远快于市场能力的,所以当市场有新的风向的时候,反而是你们可以从你们的这个已经搭建好的产品库里面,看你们在哪一个点上穿透去营销。"
      },
      {
        "id": "asr_segment_0141",
        "start_ms": 1149540,
        "end_ms": 1150740,
        "time_range": "00:19:09 - 00:19:10",
        "text": "是的,是的,是这样的。"
      },
      {
        "id": "asr_segment_0142",
        "start_ms": 1151280,
        "end_ms": 1152000,
        "time_range": "00:19:11 - 00:19:12",
        "text": "有意思。"
      },
      {
        "id": "asr_segment_0143",
        "start_ms": 1152420,
        "end_ms": 1158360,
        "time_range": "00:19:12 - 00:19:18",
        "text": "关于让AI写代码,我还有一个很核心的问题,就是怎么保证它的质量。"
      },
      {
        "id": "asr_segment_0144",
        "start_ms": 1158660,
        "end_ms": 1164340,
        "time_range": "00:19:18 - 00:19:24",
        "text": "因为Peter,其实你在你那篇推特的文章里面写到了嘛,正常情况下写代码一天,"
      },
      {
        "id": "asr_segment_0145",
        "start_ms": 1164340,
        "end_ms": 1166260,
        "time_range": "00:19:24 - 00:19:26",
        "text": "然后大家修bug要三天。"
      },
      {
        "id": "asr_segment_0146",
        "start_ms": 1166600,
        "end_ms": 1173220,
        "time_range": "00:19:26 - 00:19:33",
        "text": "现在就是有哪些新的手段加入,可以让大家不用把很多的时间都花在修复上。"
      },
      {
        "id": "asr_segment_0147",
        "start_ms": 1173640,
        "end_ms": 1178720,
        "time_range": "00:19:33 - 00:19:38",
        "text": "对,我觉得bug这个事情是一个整个engineering不可避免的一个事情。"
      },
      {
        "id": "asr_segment_0148",
        "start_ms": 1179200,
        "end_ms": 1182760,
        "time_range": "00:19:39 - 00:19:42",
        "text": "不管是AI写代码还是人写的代码都会产生bug。"
      },
      {
        "id": "asr_segment_0149",
        "start_ms": 1183240,
        "end_ms": 1187760,
        "time_range": "00:19:43 - 00:19:47",
        "text": "因为harness它不是一个静止的状态,它不是说我现在有一个系统之后,"
      },
      {
        "id": "asr_segment_0150",
        "start_ms": 1187960,
        "end_ms": 1191500,
        "time_range": "00:19:47 - 00:19:51",
        "text": "我只需要维护这个系统,这个系统不会有bug,也不需要提升。"
      },
      {
        "id": "asr_segment_0151",
        "start_ms": 1191660,
        "end_ms": 1196200,
        "time_range": "00:19:51 - 00:19:56",
        "text": "harness这个过程核心就是在于,我能不能找到这个系统中的bug。"
      },
      {
        "id": "asr_segment_0152",
        "start_ms": 1196660,
        "end_ms": 1200000,
        "time_range": "00:19:56 - 00:20:00",
        "text": "刚才聊到CICD的过程,就是在integration的时候,"
      },
      {
        "id": "asr_segment_0153",
        "start_ms": 1200000,
        "end_ms": 1229280,
        "time_range": "00:20:00 - 00:20:29",
        "text": "在测试的时候我们会有一系列的regression test去避免有一些bug可以ship到production中break这个系统。这是第一步。第二步的话即便有一些corner case或者risk conditionship到这个系统之后,我们怎么能够在最快的时间identify这些bug,然后及时的fix这些bug是第二步的事情。所以这两步就是传统的情况之下都是由人来追问的。但是在agent harness的情况之下我们会有agent的系统来追问。"
      },
      {
        "id": "asr_segment_0154",
        "start_ms": 1229440,
        "end_ms": 1241100,
        "time_range": "00:20:29 - 00:20:41",
        "text": "所以我们develop了agent driven的CICT系统和agent driven的bug triage系统,会根据系统中的issue去triage这个issue assign给engineer,让他们去fix这些bug。"
      },
      {
        "id": "asr_segment_0155",
        "start_ms": 1241620,
        "end_ms": 1245980,
        "time_range": "00:20:41 - 00:20:45",
        "text": "对,你觉得在你引入这两套系统以后,它的效率提升了多少?"
      },
      {
        "id": "asr_segment_0156",
        "start_ms": 1246300,
        "end_ms": 1258880,
        "time_range": "00:20:46 - 00:20:58",
        "text": "首先因为很多都是agent driven,所以它可以parallel的进行。所以可以有很多agent去identify,比如说有一些agent专门负责前端的bug,有一些agent专门负责后端的bug,有一些agent专门负责后端的bug,有一些负责agent核心"
      },
      {
        "id": "asr_segment_0157",
        "start_ms": 1258880,
        "end_ms": 1270000,
        "time_range": "00:20:58 - 00:21:10",
        "text": "系统的bug。所以在这个过程中,它发现一个bug可能只需要一到两分钟的时间,然后它在把这个bug assign给一个engineer的过程中,也可能也就是few second的时间。"
      },
      {
        "id": "asr_segment_0158",
        "start_ms": 1270260,
        "end_ms": 1275880,
        "time_range": "00:21:10 - 00:21:15",
        "text": "engineer拿到这个task之后,也是用agent去investigate,提出一个solution。"
      },
      {
        "id": "asr_segment_0159",
        "start_ms": 1276260,
        "end_ms": 1286660,
        "time_range": "00:21:16 - 00:21:26",
        "text": "所以整个的这个cycle加起来可能也就是一到两个小时的时间。compare之前的话,我们identify一个bug,fix一个bug,再把它ship到系统中,可能需要一个周的时间。"
      },
      {
        "id": "asr_segment_0160",
        "start_ms": 1287040,
        "end_ms": 1299120,
        "time_range": "00:21:27 - 00:21:39",
        "text": "对,这个里面有一个特别有意思的现象,就是因为我们之前所谓产言产言,就是产品和研发结合,然后我们公司以前其实是有一个feature wish list,就是你到底希望做什么样的feature,然后很长。"
      },
      {
        "id": "asr_segment_0161",
        "start_ms": 1299280,
        "end_ms": 1310460,
        "time_range": "00:21:39 - 00:21:50",
        "text": "然后呢,又有一个bug list,有很多bug要修复,然后以前呢,就总是打架,对吧,到底是先修bug,还是先做feature,市场和产品,还有工程师,大家就在那儿讨论来讨论去。"
      },
      {
        "id": "asr_segment_0162",
        "start_ms": 1310560,
        "end_ms": 1318200,
        "time_range": "00:21:50 - 00:21:58",
        "text": "现在这两个list都没有了,因为bug即时发现即时修复,feature现在的数量远远多过于我们所需要的数量。"
      },
      {
        "id": "asr_segment_0163",
        "start_ms": 1318600,
        "end_ms": 1333520,
        "time_range": "00:21:58 - 00:22:13",
        "text": "对,就是提供一个数据的话,就是我们现在有一个autofixing系统,就是这个autofixing系统是根据整个我需要fix的code是存在于哪个文件夹下,因为有一些文件夹是敏感的,有一些文件夹是相对来说risk比较小的。"
      },
      {
        "id": "asr_segment_0164",
        "start_ms": 1333520,
        "end_ms": 1345100,
        "time_range": "00:22:13 - 00:22:25",
        "text": "对于我要fix的一些东西,如果只是存在一些risk比较小的文件夹之下的话,AI会自动的提交这个pr,然后可能只需要一个engineer简单的prove一下,他就马上能够ship到production。"
      },
      {
        "id": "asr_segment_0165",
        "start_ms": 1345440,
        "end_ms": 1353880,
        "time_range": "00:22:25 - 00:22:33",
        "text": "所以可能现在50%以上的issue是通过autofixing的形式进行的,可能人在里面的参与只是简单的prove这个bug。"
      },
      {
        "id": "asr_segment_0166",
        "start_ms": 1354160,
        "end_ms": 1370520,
        "time_range": "00:22:34 - 00:22:50",
        "text": "如果这个fixing touch了一些比较sensitive的文件,比如说涉及到安全,涉及到agent behavior的话,我们可能需要专门的response这个area的people去进行一个更deeper的review,但整个的这个过程相比于之前来说也是有一个很大的提升。"
      },
      {
        "id": "asr_segment_0167",
        "start_ms": 1371220,
        "end_ms": 1373360,
        "time_range": "00:22:51 - 00:22:53",
        "text": "有什么奇怪的agent behavior呢?"
      },
      {
        "id": "asr_segment_0168",
        "start_ms": 1373920,
        "end_ms": 1389260,
        "time_range": "00:22:53 - 00:23:09",
        "text": "因为agent behavior可以break down很多area,比如说这个cost太高,或者latency太高,或者会有hallucination,或者他使用tooling的时候和tool之间的交互的authentication有问题,我觉得都涉及到agent behavior。"
      },
      {
        "id": "asr_segment_0169",
        "start_ms": 1389760,
        "end_ms": 1397540,
        "time_range": "00:23:09 - 00:23:17",
        "text": "所以任何这个系统中的issue都能导致用户具体在使用这个agent的时候不能够完成他的task。"
      },
      {
        "id": "asr_segment_0170",
        "start_ms": 1398000,
        "end_ms": 1401120,
        "time_range": "00:23:18 - 00:23:21",
        "text": "所以agent还是一个比较complicated的engineering系统。"
      },
      {
        "id": "asr_segment_0171",
        "start_ms": 1401680,
        "end_ms": 1415180,
        "time_range": "00:23:21 - 00:23:35",
        "text": "简单来说就是现在agent还没有价值观的问题,他还是效率的问题跟你灌输给他的一套思想,比如说是不是要用更便宜的cost,就同样的任务能更便宜的去完成,还是这一方面的就是效率上的问题。"
      },
      {
        "id": "asr_segment_0172",
        "start_ms": 1415180,
        "end_ms": 1419720,
        "time_range": "00:23:35 - 00:23:39",
        "text": "对,我觉得主要是效率和具体能不能够完成用户的task的层面上。"
      },
      {
        "id": "asr_segment_0173",
        "start_ms": 1420160,
        "end_ms": 1427600,
        "time_range": "00:23:40 - 00:23:47",
        "text": "就是我们所focus的就是怎么把我们的系统优化到在cost最低的情况下能够reliable的完成用户的task。"
      },
      {
        "id": "asr_segment_0174",
        "start_ms": 1427720,
        "end_ms": 1436060,
        "time_range": "00:23:47 - 00:23:56",
        "text": "对,比如说当系统出现一个bug的时候,假设我是在改一篇稿子,即使它只出现了一个小错误,我可能需要把整个稿子看一遍。"
      },
      {
        "id": "asr_segment_0175",
        "start_ms": 1436420,
        "end_ms": 1439260,
        "time_range": "00:23:56 - 00:23:59",
        "text": "然后呢,我再去看那个错误是在哪儿,我怎么去修改。"
      },
      {
        "id": "asr_segment_0176",
        "start_ms": 1439600,
        "end_ms": 1448900,
        "time_range": "00:23:59 - 00:24:08",
        "text": "那这个时间其实就跟比如说我自己重新写,重新熟悉这个领域,它的时间花的是差不多的,因为我不太懂写代码,只能用写文章做比喻。"
      },
      {
        "id": "asr_segment_0177",
        "start_ms": 1449240,
        "end_ms": 1459640,
        "time_range": "00:24:09 - 00:24:19",
        "text": "对于到开发的领域,就比如说agent帮你搭了一个非常好的技术框架,但是呢它可能在整个搭建层或者基础层出现了一个大的错误。"
      },
      {
        "id": "asr_segment_0178",
        "start_ms": 1459640,
        "end_ms": 1475060,
        "time_range": "00:24:19 - 00:24:35",
        "text": "那这个时候当然有其他的很多的agent要去修复,但会不会说比如说有一些大的错误,大到了需要工程师去解决,但是工程师去解决的时候我不能只看这一个点,我要先看你整个的构成是怎么样的。"
      },
      {
        "id": "asr_segment_0179",
        "start_ms": 1475320,
        "end_ms": 1481140,
        "time_range": "00:24:35 - 00:24:41",
        "text": "然后我才能去解决那个细分的问题,它同样要花的时间,就是我还得把这个重新学一遍。"
      },
      {
        "id": "asr_segment_0180",
        "start_ms": 1481500,
        "end_ms": 1491300,
        "time_range": "00:24:41 - 00:24:51",
        "text": "对,我觉得这个问题很好,所以在之前的我的文章中我也讨论了在AI环境之下的工程团队可能分为两种人,一种是architecture,一种是operator。"
      },
      {
        "id": "asr_segment_0181",
        "start_ms": 1491480,
        "end_ms": 1504940,
        "time_range": "00:24:51 - 00:25:04",
        "text": "所以architecture在整个这个系统搭建过程中的作用是非常重要的,比如说在搭建整个quill的系统的过程之中,整个agent的architecture是什么样子的,比如说sandbox和host之间是怎么交互的,"
      },
      {
        "id": "asr_segment_0182",
        "start_ms": 1505200,
        "end_ms": 1520580,
        "time_range": "00:25:05 - 00:25:20",
        "text": "还是由architecture来决定的。如果说agent直接通过AI coding或web coding的方式,它通常来讲会给你一个solution,但这个solution通常会有安全的隐患或者latency的隐患,怎么去优化整个的这个系统还是由architecture来决定的。"
      },
      {
        "id": "asr_segment_0183",
        "start_ms": 1520580,
        "end_ms": 1533260,
        "time_range": "00:25:20 - 00:25:33",
        "text": "但通常来讲,我觉得区别就是在传统的情况之下,搭建agent的团队以前可能需要10到20个人,但是现在搭建整个这样一个系统只需要一个architecture,在一个周的时间之内就能完成。"
      },
      {
        "id": "asr_segment_0184",
        "start_ms": 1533480,
        "end_ms": 1534980,
        "time_range": "00:25:33 - 00:25:34",
        "text": "你现在是那个architecture。"
      },
      {
        "id": "asr_segment_0185",
        "start_ms": 1535320,
        "end_ms": 1547420,
        "time_range": "00:25:35 - 00:25:47",
        "text": "当然从一开始我们在develop这个系统的时候,需要我来architecture整个的系统,去demonstrate给整个的团队,整个这个architecture是比之前更优化,效率更高,cost更低。"
      },
      {
        "id": "asr_segment_0186",
        "start_ms": 1547480,
        "end_ms": 1550500,
        "time_range": "00:25:47 - 00:25:50",
        "text": "我来补充一下刚刚Peter所讲的内容吧。"
      },
      {
        "id": "asr_segment_0187",
        "start_ms": 1550900,
        "end_ms": 1565520,
        "time_range": "00:25:50 - 00:26:05",
        "text": "第一就是我觉得AI的能力在很早以前就已经非常强了,但是它为什么没有达到人们所预期的那样说,今天AI可以替我干活,它如果没有干好,我还得帮它去弥补它的错误。"
      },
      {
        "id": "asr_segment_0188",
        "start_ms": 1565900,
        "end_ms": 1570180,
        "time_range": "00:26:05 - 00:26:10",
        "text": "我觉得这个点来讲就是harness在这个过程中非常重要去发挥价值的地方。"
      },
      {
        "id": "asr_segment_0189",
        "start_ms": 1570600,
        "end_ms": 1577600,
        "time_range": "00:26:10 - 00:26:17",
        "text": "这个主要里面有一个很大的一个概念上的转变,就是我们要把AI当成一个系统来看待,不要把它当成一个智能来看待。"
      },
      {
        "id": "asr_segment_0190",
        "start_ms": 1577900,
        "end_ms": 1589900,
        "time_range": "00:26:17 - 00:26:29",
        "text": "虽然系统是由智能所驱动的,但这里面一个核心的差距就是,当AI或者说这个系统发生错误的时候,我们不要想着怎么样去纠正这个智能,我们要想着怎么样去弥补这个系统。"
      },
      {
        "id": "asr_segment_0191",
        "start_ms": 1590060,
        "end_ms": 1605800,
        "time_range": "00:26:30 - 00:26:45",
        "text": "这个其实就是我们在做harness跟现在普遍的认知最不一样的地方就是,它是一个动态改变和提升的一个过程,并不是一个静态的固定的枷锁去束缚这个智能,而是要给它提供空间让它能够成长。"
      },
      {
        "id": "asr_segment_0192",
        "start_ms": 1606140,
        "end_ms": 1612980,
        "time_range": "00:26:46 - 00:26:52",
        "text": "这个成长的方式就好像你在养一个孩子,你怎么样能够让它不断的在一个规则内变得越来越好。"
      },
      {
        "id": "asr_segment_0193",
        "start_ms": 1613360,
        "end_ms": 1620400,
        "time_range": "00:26:53 - 00:27:00",
        "text": "我们做harness其实是在给用户提供说我们给你一个培训师去弥补它在发现错误之后,你该怎么办。"
      },
      {
        "id": "asr_segment_0194",
        "start_ms": 1620700,
        "end_ms": 1633600,
        "time_range": "00:27:00 - 00:27:13",
        "text": "回答您刚刚那个问题,如果您在写作的时候发现说,OK,有一个巨大的问题,我觉得您应该花更多的时间去思考这个系统上面有没有漏洞,而不是我要去花更多的时间去改正具体的某一个错误。"
      },
      {
        "id": "asr_segment_0195",
        "start_ms": 1633600,
        "end_ms": 1642380,
        "time_range": "00:27:13 - 00:27:22",
        "text": "这个里面还有一个更加极端的一个想法就是,您今天发的这些内容,或者我们自己发的这些内容,可能未来的这些受众并不一定是人。"
      },
      {
        "id": "asr_segment_0196",
        "start_ms": 1642700,
        "end_ms": 1652280,
        "time_range": "00:27:22 - 00:27:32",
        "text": "这个错误可能对人来说是一个很致命的错误,但对于未来可能都是AI在读文章,或者AI在读我们的图片视频,对他们来讲可能并不是一个很致命的错误。"
      },
      {
        "id": "asr_segment_0197",
        "start_ms": 1652280,
        "end_ms": 1662220,
        "time_range": "00:27:32 - 00:27:42",
        "text": "所以我觉得大家其实在这个过程中要思考更多的就是,我今天做的这个工作,到底是未来谁来去消费我的工作和我的这些结果。"
      },
      {
        "id": "asr_segment_0198",
        "start_ms": 1662620,
        "end_ms": 1672940,
        "time_range": "00:27:42 - 00:27:52",
        "text": "根据你的这些消费者他们的偏好调整你harness的这个系统,才能够更好地达到你所能够希望去deliver的价值。"
      },
      {
        "id": "asr_segment_0199",
        "start_ms": 1673500,
        "end_ms": 1689500,
        "time_range": "00:27:53 - 00:28:09",
        "text": "我觉得这个观点非常有意思,就是大家以前在出现问题的时候都是说我们解决问题,现在说的是,OK我们解决搭建的环境中的系统上的问题,而不是一个单一的问题,就是彻底上修复它,以后它这个问题就永远都不要再出现了。"
      },
      {
        "id": "asr_segment_0200",
        "start_ms": 1689600,
        "end_ms": 1716280,
        "time_range": "00:28:09 - 00:28:36",
        "text": "对,与其说是彻底修复它,不如说是我们重新思考这个问题它是否还是一个问题,比如说我们平常会生产一些go to market的asset,比如说有些图片我们觉得可能从人的审美上去看,它并不是一个很好的一个asset,但实际上你把这个东西投向市场的时候,你会发现可能读这篇文章或者读这个图片是一个agent在读,它的数据反馈回来其实可能是更好的。"
      },
      {
        "id": "asr_segment_0201",
        "start_ms": 1716540,
        "end_ms": 1733320,
        "time_range": "00:28:36 - 00:28:53",
        "text": "如果我们与其去说,OK今天人觉得这个东西它不够好,我们要去修复人主观对这个东西的价值判断,那我们与其去修复说整个不管是我们自己的系统还是别人的系统对这个事情的价值判断,它其实是从价值理解上面就会发生偏差。"
      },
      {
        "id": "asr_segment_0202",
        "start_ms": 1733640,
        "end_ms": 1740340,
        "time_range": "00:28:53 - 00:29:00",
        "text": "为什么会是agent在读一个营销图片,就是你们的下载是针对谁的,是针对agent的还是针对人的?"
      },
      {
        "id": "asr_segment_0203",
        "start_ms": 1740600,
        "end_ms": 1751840,
        "time_range": "00:29:00 - 00:29:11",
        "text": "现在大家也比较感兴趣的话题就是以后会不会有这样的agent经济,可能买东西是由agent去买,订报纸是由agent去订,订牛奶是由agent去订,那你的广告是发给agent看还是发给人看?"
      },
      {
        "id": "asr_segment_0204",
        "start_ms": 1752140,
        "end_ms": 1771700,
        "time_range": "00:29:12 - 00:29:31",
        "text": "因为我现在自己看很多文章,看很多视频,也是让agent去看,所以你要搞清楚你的内容到底是被谁消费,你的工作结果到底是被谁消费,针对这个东西的价值我们再去思考我们到底是提升系统,还是我们回到最原始的人要参与到这个创作的过程中去弥补我们一些错误。"
      },
      {
        "id": "asr_segment_0205",
        "start_ms": 1772060,
        "end_ms": 1791100,
        "time_range": "00:29:32 - 00:29:51",
        "text": "我相信在未来,真的是在agent帮大家做更多的购买决策的时候呢,最终的结果可能还是agent看得多,但是我没有想到在现阶段,包括你在现阶段测试的这个流量中,agent已经占到了一个这么大的比例,就是它来的比我预期中要快很多。"
      },
      {
        "id": "asr_segment_0206",
        "start_ms": 1791660,
        "end_ms": 1800000,
        "time_range": "00:29:51 - 00:30:00",
        "text": "是的,一个亲身的经历,我最近在看有什么样的公司能帮我们做合规的,比如说SOC2,ISO,一些认证,那我肯定是,"
      },
      {
        "id": "asr_segment_0207",
        "start_ms": 1800000,
        "end_ms": 1827020,
        "time_range": "00:30:00 - 00:30:27",
        "text": "是让Agent先去帮我research一番。然后我基于他的结果,我来看一看是不是适合我们。那这个里面你会发现第一步已经是在Agent帮你做这个筛选了。那是不是那些内容,他应该更偏向Agent去做,而不是偏向人去做。当然我点进去,再去看某些东西的时候,可能需要有面向人,一直就需要消费的内容。但是有可能他会把第二层也做掉了以后,甚至第三层也做掉。所以这个我觉得都是可能会发生的事情。"
      },
      {
        "id": "asr_segment_0208",
        "start_ms": 1827320,
        "end_ms": 1856480,
        "time_range": "00:30:27 - 00:30:56",
        "text": "这个从另外一个角度上来讲,也可以很明显地看到就是现在SaaS产品的转型。因为以前很多SaaS产品,尤其是像Asana、Linear这种的产品,做Task Management,它需要一个Dashboard。以前可能很多的都是人在去看这些Dashboard,Manage这些Dashboard。但是在起码现在这个阶段,我们团队在使用Task Management的时候,我们更关心的是Agent能不能够更好地看这些Task,Prioritize这些Task。"
      },
      {
        "id": "asr_segment_0209",
        "start_ms": 1856640,
        "end_ms": 1866680,
        "time_range": "00:30:56 - 00:31:06",
        "text": "所以instead of人去看这些或使用这些Dashboard,更多的是我们会去看这些Task Management产品有没有更好的MCP和API提供给Agent可以让我们使用。"
      },
      {
        "id": "asr_segment_0210",
        "start_ms": 1866980,
        "end_ms": 1869520,
        "time_range": "00:31:06 - 00:31:09",
        "text": "对,所以整个进化还是非常的快的。"
      },
      {
        "id": "asr_segment_0211",
        "start_ms": 1869820,
        "end_ms": 1875800,
        "time_range": "00:31:09 - 00:31:15",
        "text": "其实刚才您提到这个问题,也是很多公司他在做AI转型的时候会第一个考虑的问题。"
      },
      {
        "id": "asr_segment_0212",
        "start_ms": 1876220,
        "end_ms": 1884040,
        "time_range": "00:31:16 - 00:31:24",
        "text": "他可能会看到下面有很多的员工也好,或者说他的管理层会觉得,我使用AI的时候,如果我还要去review一遍,那跟我人去做。"
      },
      {
        "id": "asr_segment_0213",
        "start_ms": 1884040,
        "end_ms": 1888100,
        "time_range": "00:31:24 - 00:31:28",
        "text": "其实这个不管你是时间也好,还是你的成本也好,可能没有太大差别。"
      },
      {
        "id": "asr_segment_0214",
        "start_ms": 1888420,
        "end_ms": 1898980,
        "time_range": "00:31:28 - 00:31:38",
        "text": "但是就像刚才Peter说,如果你真的能够把这样子的一个AI系统给构建起来之后,你会发现其实你仔细去算一下,你会发现你的时间和你的成本是会有很大的一个提升的。"
      },
      {
        "id": "asr_segment_0215",
        "start_ms": 1899220,
        "end_ms": 1907320,
        "time_range": "00:31:39 - 00:31:47",
        "text": "只是这个过程需要整个团队一起有一个共同的一个目标说,今天我就是要把公司的组织结构也好,工作方式也好,都去改变。"
      },
      {
        "id": "asr_segment_0216",
        "start_ms": 1907680,
        "end_ms": 1917280,
        "time_range": "00:31:47 - 00:31:57",
        "text": "他这个过程当中只要有那么一些人,他可能觉得做很多东西可能还不如人去做,那这个过程就会让改造的时间会被拉长,以及这个过程就会变得特别不顺利。"
      },
      {
        "id": "asr_segment_0217",
        "start_ms": 1917540,
        "end_ms": 1921580,
        "time_range": "00:31:57 - 00:32:01",
        "text": "这个其实是一个大多数公司都会面临的一个从组织上来讲的一个挑战。"
      },
      {
        "id": "asr_segment_0218",
        "start_ms": 1921940,
        "end_ms": 1936320,
        "time_range": "00:32:01 - 00:32:16",
        "text": "你们是第一天就这种AI first的工作方式,还是说因为其实你们也成立一年多了,而这一年多我觉得是整个行业里面变化最快的一个时间段,还是说你们在后面慢慢地摸索到这样的一套工作方式的?"
      },
      {
        "id": "asr_segment_0219",
        "start_ms": 1936560,
        "end_ms": 1958100,
        "time_range": "00:32:16 - 00:32:38",
        "text": "我觉得我们整个公司也是有一个过程的,你意识到谁是未来的生产力的核心的角色,可能在二五年的上半年的时候,大家都会觉得可能那个时间点还是AI是辅助人去做事情,那人在整个工作里面还是占主导地位的,但是到了下半年的时候我们会意识到如果还是这样子的话,那其实企业的效率提升还是非常有限的。"
      },
      {
        "id": "asr_segment_0220",
        "start_ms": 1958140,
        "end_ms": 1970200,
        "time_range": "00:32:38 - 00:32:50",
        "text": "因为我们也用了这样的方式,我们会发现好像效率没有提升得由我们想象那么多,所以我们会发现那里面核心问题,我们还是没有把这个生产力工具的使用者真正地从人转变到AI。"
      },
      {
        "id": "asr_segment_0221",
        "start_ms": 1970700,
        "end_ms": 1976820,
        "time_range": "00:32:50 - 00:32:56",
        "text": "这个过程如果没有彻底地去改造它,我会发现可能还不如我人去做这个事情来得更高效。"
      },
      {
        "id": "asr_segment_0222",
        "start_ms": 1976960,
        "end_ms": 1991440,
        "time_range": "00:32:56 - 00:33:11",
        "text": "所以说这个过程也是需要一个非常长的过程,还有包括像刚才Kark跟Peter提到,不光是技术团队内部会有这样的一个挑战,还有包括marketing团队和开发团队之间,他们在对齐的时候,大家都需要一个理解的过程。"
      },
      {
        "id": "asr_segment_0223",
        "start_ms": 1991780,
        "end_ms": 2002980,
        "time_range": "00:33:11 - 00:33:22",
        "text": "我们也因为这个理解的过程会浪费一些时间在上面,就比如说市场团队跟engineer团队有很长的一段时间,可能甚至一个月或两个月都在来来回回地探讨怎么样一个更好的方式工作。"
      },
      {
        "id": "asr_segment_0224",
        "start_ms": 2003140,
        "end_ms": 2008480,
        "time_range": "00:33:23 - 00:33:28",
        "text": "这个其实都是组织的进化,它需要一个过程,这过程一定不是从第一天开始就是这样的。"
      },
      {
        "id": "asr_segment_0225",
        "start_ms": 2008920,
        "end_ms": 2030520,
        "time_range": "00:33:28 - 00:33:50",
        "text": "我觉得这个也是跟整个AI能力相关的,从过去的一年之内,AI从一个辅助engineer的角色,到一个参与到开发过程中的一个角色,到现在能够相对来说主导开发过程的一个角色,是根据本身基础模型能力的提升,agent架构的提升,和agent infrastructure的提升都是相关的。"
      },
      {
        "id": "asr_segment_0226",
        "start_ms": 2030620,
        "end_ms": 2037040,
        "time_range": "00:33:50 - 00:33:57",
        "text": "比如说一年之前如果想让我们说用AI主导整个的这个开发过程中,我觉得从技术上来说是不成立的。"
      },
      {
        "id": "asr_segment_0227",
        "start_ms": 2037040,
        "end_ms": 2049740,
        "time_range": "00:33:57 - 00:34:09",
        "text": "但是从整个重构过程中,我们发现当AI reached到这个point的时候,整个的重构不管是从速度还是从效果上来讲都是远超于一年之前能够想象的一个程度。"
      },
      {
        "id": "asr_segment_0228",
        "start_ms": 2050280,
        "end_ms": 2057880,
        "time_range": "00:34:10 - 00:34:17",
        "text": "你们是从哪个时间点开始重构的?然后这个重构的时候,整个市场发生了什么?你们做的最核心的几件事情是什么?"
      },
      {
        "id": "asr_segment_0229",
        "start_ms": 2058500,
        "end_ms": 2064640,
        "time_range": "00:34:18 - 00:34:24",
        "text": "对,其实我们意识到需要重构这个事情,可能是去年八九月份的时候。"
      },
      {
        "id": "asr_segment_0230",
        "start_ms": 2065100,
        "end_ms": 2073560,
        "time_range": "00:34:25 - 00:34:33",
        "text": "之前的话我们会花一些时间进行团队的alignment,其实engineer,产品团队和marketing团队,大家的mindset是最重要的。"
      },
      {
        "id": "asr_segment_0231",
        "start_ms": 2073860,
        "end_ms": 2078380,
        "time_range": "00:34:33 - 00:34:38",
        "text": "所以我们可能花的最多的时间就是怎么让大家转变这个mindset。"
      },
      {
        "id": "asr_segment_0232",
        "start_ms": 2078920,
        "end_ms": 2092000,
        "time_range": "00:34:38 - 00:34:52",
        "text": "我们真的开始重构我们的代码架构,整个的开发的过程,可能也就是今年一月份的时间,就是今年过年之前,我们在使用了大概两个周的时间,就重构了整个我们的所有的架构。"
      },
      {
        "id": "asr_segment_0233",
        "start_ms": 2092420,
        "end_ms": 2097240,
        "time_range": "00:34:52 - 00:34:57",
        "text": "包括现在大家看到的产品也是根据这个阶段重构的过程中的这样一个产品。"
      },
      {
        "id": "asr_segment_0234",
        "start_ms": 2097600,
        "end_ms": 2104440,
        "time_range": "00:34:57 - 00:35:04",
        "text": "有哪些你们觉得之前AI解决不了的事情,然后AI解决了,可不可以举两个例子?"
      },
      {
        "id": "asr_segment_0235",
        "start_ms": 2104800,
        "end_ms": 2113040,
        "time_range": "00:35:04 - 00:35:13",
        "text": "之前AI解决不了的事情主要是在planning阶段,比如说我以100分为score的话,它能给我一个90分的score。"
      },
      {
        "id": "asr_segment_0236",
        "start_ms": 2113360,
        "end_ms": 2121000,
        "time_range": "00:35:13 - 00:35:21",
        "text": "我看到这个plan的时候,我能够再给它一些criticize,它能够给我一个revised plan,而不需要我真实的去改这个plan。"
      },
      {
        "id": "asr_segment_0237",
        "start_ms": 2121120,
        "end_ms": 2128160,
        "time_range": "00:35:21 - 00:35:28",
        "text": "比如说我说现在这个情况下能够达90分的话,那一年之前的话可能也就是50分,一个不及格的状态。"
      },
      {
        "id": "asr_segment_0238",
        "start_ms": 2128320,
        "end_ms": 2132480,
        "time_range": "00:35:28 - 00:35:32",
        "text": "我可能需要人为的再去modify这个plan,再去改整个架构。"
      },
      {
        "id": "asr_segment_0239",
        "start_ms": 2132580,
        "end_ms": 2139220,
        "time_range": "00:35:32 - 00:35:39",
        "text": "但是现在的话,比如说整个我们这个新架构,我可以说我一行code也没有写,一行的text也没有去改这个plan。"
      },
      {
        "id": "asr_segment_0240",
        "start_ms": 2139540,
        "end_ms": 2144320,
        "time_range": "00:35:39 - 00:35:44",
        "text": "我只是在跟它进行交流,我criticize你这个plan是不是有缺陷,是不是优化的。"
      },
      {
        "id": "asr_segment_0241",
        "start_ms": 2144640,
        "end_ms": 2151960,
        "time_range": "00:35:44 - 00:35:51",
        "text": "在credit这个plan的时候,你可不可以reference一下其他popular的open source的framework,或agent framework,你给我一个最终的版本。"
      },
      {
        "id": "asr_segment_0242",
        "start_ms": 2152340,
        "end_ms": 2155740,
        "time_range": "00:35:52 - 00:35:55",
        "text": "你觉得它的能力在你之上吗?AI写代码的能力。"
      },
      {
        "id": "asr_segment_0243",
        "start_ms": 2156200,
        "end_ms": 2159280,
        "time_range": "00:35:56 - 00:35:59",
        "text": "首先AI写代码的能力肯定是在我之上的,因为我没有写。"
      },
      {
        "id": "asr_segment_0244",
        "start_ms": 2159540,
        "end_ms": 2160300,
        "time_range": "00:35:59 - 00:36:00",
        "text": "Planning的能力。"
      },
      {
        "id": "asr_segment_0245",
        "start_ms": 2160540,
        "end_ms": 2162780,
        "time_range": "00:36:00 - 00:36:02",
        "text": "2026年,我就没有写过一行代码。"
      },
      {
        "id": "asr_segment_0246",
        "start_ms": 2163180,
        "end_ms": 2175900,
        "time_range": "00:36:03 - 00:36:15",
        "text": "但是从planning的能力上来讲的话,作为一个architecture的价值,或者在一个公司里面,不管你是一个CTO,还是一个tech lead,你的价值就是在于找到AI planning的缺陷。"
      },
      {
        "id": "asr_segment_0247",
        "start_ms": 2176460,
        "end_ms": 2181520,
        "time_range": "00:36:16 - 00:36:21",
        "text": "所以本身architecture和不管是tech lead,在这个之上还是有价值的。"
      },
      {
        "id": "asr_segment_0248",
        "start_ms": 2181920,
        "end_ms": 2184660,
        "time_range": "00:36:21 - 00:36:24",
        "text": "我只能说现在AI的planning还是有缺陷的。"
      },
      {
        "id": "asr_segment_0249",
        "start_ms": 2184880,
        "end_ms": 2188680,
        "time_range": "00:36:24 - 00:36:28",
        "text": "比如说它一开始给我的planning可能有security的缺陷,可能有latency的缺陷。"
      },
      {
        "id": "asr_segment_0250",
        "start_ms": 2188680,
        "end_ms": 2195500,
        "time_range": "00:36:28 - 00:36:35",
        "text": "那我根据我之前的architecture的经验,我怎么能够criticize它,或者challenge它,能够进行进一步的提升。"
      },
      {
        "id": "asr_segment_0251",
        "start_ms": 2195900,
        "end_ms": 2204860,
        "time_range": "00:36:35 - 00:36:44",
        "text": "对,然后你们是一月开始做转型的,到现在,你觉得AI现在在做planning,就是你交给了它,我们要怎么去做这个latency,安全性。"
      },
      {
        "id": "asr_segment_0252",
        "start_ms": 2205380,
        "end_ms": 2209080,
        "time_range": "00:36:45 - 00:36:49",
        "text": "它现在在做新的计划的时候,它会变得好很多吗?"
      },
      {
        "id": "asr_segment_0253",
        "start_ms": 2209420,
        "end_ms": 2211140,
        "time_range": "00:36:49 - 00:36:51",
        "text": "对,我觉得这个就是harness的核心。"
      },
      {
        "id": "asr_segment_0254",
        "start_ms": 2211520,
        "end_ms": 2217960,
        "time_range": "00:36:51 - 00:36:57",
        "text": "之前我交给它,你在安全性上,在设计sandbox和host之间的关系的时候,你要follow什么样的准则。"
      },
      {
        "id": "asr_segment_0255",
        "start_ms": 2218140,
        "end_ms": 2220820,
        "time_range": "00:36:58 - 00:37:00",
        "text": "那这个时候,我就可以把它变成一个skill。"
      },
      {
        "id": "asr_segment_0256",
        "start_ms": 2221120,
        "end_ms": 2231240,
        "time_range": "00:37:01 - 00:37:11",
        "text": "那在下一次的过程之中,我只需要reference这个skill, instead of我去说更具体的内容,我说你能不能follow我这个principle,就变成一件很容易的事情。"
      },
      {
        "id": "asr_segment_0257",
        "start_ms": 2231360,
        "end_ms": 2242780,
        "time_range": "00:37:11 - 00:37:22",
        "text": "而且不光是我自己能够challenge AI,包括所有其他的我们团队的engineer也可以reference这个skill,看AI的plan能够follow之前的我们的这些principle。"
      },
      {
        "id": "asr_segment_0258",
        "start_ms": 2243240,
        "end_ms": 2245740,
        "time_range": "00:37:23 - 00:37:25",
        "text": "可不可以给听众一个直观的印象啊?"
      },
      {
        "id": "asr_segment_0259",
        "start_ms": 2245920,
        "end_ms": 2254880,
        "time_range": "00:37:25 - 00:37:34",
        "text": "你现在有了AI做生产的主力以后,他干出了配多少员工才能干到的事情,给大家一个数字上的直观的感受。"
      },
      {
        "id": "asr_segment_0260",
        "start_ms": 2255040,
        "end_ms": 2262240,
        "time_range": "00:37:35 - 00:37:42",
        "text": "就比如说以前一个团队,他需要20个人做四周,我随便说,现在就多长时间就做到了。"
      },
      {
        "id": "asr_segment_0261",
        "start_ms": 2262640,
        "end_ms": 2274620,
        "time_range": "00:37:42 - 00:37:54",
        "text": "如果翻到一年之前,我们不是AI主导的情况之下,要develop像krill现在一个产品,我就起码需要100人左右的团队,花四五个月的时间去develop这样一个版本。"
      },
      {
        "id": "asr_segment_0262",
        "start_ms": 2275080,
        "end_ms": 2279760,
        "time_range": "00:37:55 - 00:37:59",
        "text": "如果大家看其他的general agent的公司的company size,大概也是这样一个范围。"
      },
      {
        "id": "asr_segment_0263",
        "start_ms": 2279920,
        "end_ms": 2281280,
        "time_range": "00:37:59 - 00:38:01",
        "text": "现在是25个人。"
      },
      {
        "id": "asr_segment_0264",
        "start_ms": 2281500,
        "end_ms": 2284460,
        "time_range": "00:38:01 - 00:38:04",
        "text": "我们的engineer团队可能是10人以下。"
      },
      {
        "id": "asr_segment_0265",
        "start_ms": 2284580,
        "end_ms": 2286040,
        "time_range": "00:38:04 - 00:38:06",
        "text": "10人以下,多长时间?"
      },
      {
        "id": "asr_segment_0266",
        "start_ms": 2287240,
        "end_ms": 2291440,
        "time_range": "00:38:07 - 00:38:11",
        "text": "从产品的第一个阶段的deployment可能也花了大概两周的时间。"
      },
      {
        "id": "asr_segment_0267",
        "start_ms": 2291820,
        "end_ms": 2295920,
        "time_range": "00:38:11 - 00:38:15",
        "text": "两周的时间,10个人以下,这个效率提升很高的。"
      },
      {
        "id": "asr_segment_0268",
        "start_ms": 2296300,
        "end_ms": 2302520,
        "time_range": "00:38:16 - 00:38:22",
        "text": "对,从创业公司角度来看,或者说很多SaaS公司运营一个SaaS产品的时候,你会有个很直观感受。"
      },
      {
        "id": "asr_segment_0269",
        "start_ms": 2302620,
        "end_ms": 2311520,
        "time_range": "00:38:22 - 00:38:31",
        "text": "就是在原来的传统的软件时代下,你会发现销售团队,他们在概念角度来讲,会超前你自己的产品可能四到五个月。"
      },
      {
        "id": "asr_segment_0270",
        "start_ms": 2312000,
        "end_ms": 2316400,
        "time_range": "00:38:32 - 00:38:36",
        "text": "可能大多数你的用户看到的是你四到五个月之后才会发布的一些功能。"
      },
      {
        "id": "asr_segment_0271",
        "start_ms": 2316780,
        "end_ms": 2318820,
        "time_range": "00:38:36 - 00:38:38",
        "text": "但现在这个情况下,它是反过来的。"
      },
      {
        "id": "asr_segment_0272",
        "start_ms": 2318820,
        "end_ms": 2324320,
        "time_range": "00:38:38 - 00:38:44",
        "text": "比如说KAR这边的Marketing团队会感觉就是说,我们有很多很多功能,我们甚至都不知道它已经做完了。"
      },
      {
        "id": "asr_segment_0273",
        "start_ms": 2324760,
        "end_ms": 2329480,
        "time_range": "00:38:44 - 00:38:49",
        "text": "就技术团队可能是反过来是超前了Marketing团队可能三到四个月或四到五个月。"
      },
      {
        "id": "asr_segment_0274",
        "start_ms": 2329760,
        "end_ms": 2333980,
        "time_range": "00:38:49 - 00:38:53",
        "text": "更多时候变成Marketing团队在追赶开发团队的一些功能还有安排。"
      },
      {
        "id": "asr_segment_0275",
        "start_ms": 2334300,
        "end_ms": 2337640,
        "time_range": "00:38:54 - 00:38:57",
        "text": "那这个就是一个我们从最外层来看,它最大的一个区别。"
      },
      {
        "id": "asr_segment_0276",
        "start_ms": 2337940,
        "end_ms": 2342680,
        "time_range": "00:38:57 - 00:39:02",
        "text": "那这个区别就会导致你的整个运营方式,它包括你的整个组织结构可能都会跟原来不一样。"
      },
      {
        "id": "asr_segment_0277",
        "start_ms": 2343080,
        "end_ms": 2348480,
        "time_range": "00:39:03 - 00:39:08",
        "text": "凯也提到了现在整个技术开发的速度是大于市场营销的速度的。"
      },
      {
        "id": "asr_segment_0278",
        "start_ms": 2348840,
        "end_ms": 2355200,
        "time_range": "00:39:08 - 00:39:15",
        "text": "Clark你这一块会有从市场营销的层面也用更多的Agent,因为技术可以用,你们也可以用嘛。"
      },
      {
        "id": "asr_segment_0279",
        "start_ms": 2355200,
        "end_ms": 2368860,
        "time_range": "00:39:15 - 00:39:28",
        "text": "我知道代码Agent这两年特别特别的火,那在整个Marketing的素材生成方面,以及这个素材的产出方面,或者是你其他的一些流程方向,你觉得现在这一块的Agent的发展怎么样了?"
      },
      {
        "id": "asr_segment_0280",
        "start_ms": 2369120,
        "end_ms": 2378160,
        "time_range": "00:39:29 - 00:39:38",
        "text": "所以我们现在整个GoToMarketing都会用我们自己公司的产品去构建AI First GoToMarket的workflow或者流程。"
      },
      {
        "id": "asr_segment_0281",
        "start_ms": 2378240,
        "end_ms": 2389060,
        "time_range": "00:39:38 - 00:39:49",
        "text": "当然这里面有很多坑,我觉得最大的一个困惑就是Engineer它是一个相对比较好去做Evaluation,相对封闭的一个环境。"
      },
      {
        "id": "asr_segment_0282",
        "start_ms": 2389540,
        "end_ms": 2400000,
        "time_range": "00:39:49 - 00:40:00",
        "text": "它能够有明确的指标说今天你干得好还是不好,但是从GoToMarket的角度,不管是你是写文章也好,做视频也好,你是面向人,"
      },
      {
        "id": "asr_segment_0283",
        "start_ms": 2400000,
        "end_ms": 2420540,
        "time_range": "00:40:00 - 00:40:20",
        "text": "的消费群体它对于这个事情的价值的认可和面向Agent或者不同的人群,每个人他都有自己对这个价值的判断,这个是相对来说比较主观的,那我们怎么样去构建这个系统能够更好地把这些主观的判断变成一种信号,让我们的系统能够自动去运转起来,这个是一个比较大的挑战。"
      },
      {
        "id": "asr_segment_0284",
        "start_ms": 2420640,
        "end_ms": 2436720,
        "time_range": "00:40:20 - 00:40:36",
        "text": "我们也没有说我们今天就是百分之百让Agent去做决策,但我们会放很多Agent的结果,再由人再去判断说这个结果好还是不好,我们有很多很多的feature,但我觉得市场还没有ready,那我们就不会把这些东西放到市场上面去。"
      },
      {
        "id": "asr_segment_0285",
        "start_ms": 2437100,
        "end_ms": 2441120,
        "time_range": "00:40:37 - 00:40:41",
        "text": "我很好奇你们有哪些超前的思想是市场还没有接受的?"
      },
      {
        "id": "asr_segment_0286",
        "start_ms": 2441460,
        "end_ms": 2468580,
        "time_range": "00:40:41 - 00:41:08",
        "text": "每个人的Agent都有所有的权限可以读写,这个其实是一个相对来说比较大胆的一个动作,我们希望说未来为了能够让你的组织更加高效,你的很多数据是应该开放给你的Agent,开放给每一个人,但这里面可能还需要更好的一些技术的支持,包括你怎么样去限制每个人的权限或者限制Agent权限,怎么样让Agent在读取这些数据的时候不会出现失误。"
      },
      {
        "id": "asr_segment_0287",
        "start_ms": 2468660,
        "end_ms": 2494820,
        "time_range": "00:41:08 - 00:41:34",
        "text": "因为如果他读的数据是错的,或者他自己开始乱搞,那你最后的决策可能会受到很大的影响,所以这个我觉得还没有ready推向市场,但是至少我们自己用起来很爽,比如说我原来我要说Peter今天我们有多少个用户有这样的行为,可能还要去找做数据的同学或者是engineer去帮我打一个新的表格出来,但今天我只需要跟Agent说我提这个问题,他立刻三秒钟之后给我一个答复。"
      },
      {
        "id": "asr_segment_0288",
        "start_ms": 2495300,
        "end_ms": 2511020,
        "time_range": "00:41:35 - 00:41:51",
        "text": "我觉得现在主要的challenge对于大部分Agent的公司来说,不是市场能不能接受这种工作方式,而是市场不知道这种工作方式的存在,或者他不知道怎么去高效地使用一个Agent,帮助他能够完成他的work。"
      },
      {
        "id": "asr_segment_0289",
        "start_ms": 2511420,
        "end_ms": 2523380,
        "time_range": "00:41:51 - 00:42:03",
        "text": "所以Crew在整个的这个过程中,我们也做了很多工作,就是让用户不用进行复杂的设置,才能够更容易去access这个Agent,帮助他完成他自己本身的工作。"
      },
      {
        "id": "asr_segment_0290",
        "start_ms": 2523900,
        "end_ms": 2528200,
        "time_range": "00:42:03 - 00:42:08",
        "text": "嗯,这是不是也是你们公司现在在做的事情,就是让AI自己去创建Agent。"
      },
      {
        "id": "asr_segment_0291",
        "start_ms": 2528580,
        "end_ms": 2544200,
        "time_range": "00:42:08 - 00:42:24",
        "text": "对,我把上一个时代的general agent理解成这些公司会提供一个Agent,用户会使用这个Agent去帮助他们完成自己的一些工作,但这个Agent不管把它叫做general agent还是super agent,它是一个unique的Agent,所有用户access是同一个Agent。"
      },
      {
        "id": "asr_segment_0292",
        "start_ms": 2544360,
        "end_ms": 2556940,
        "time_range": "00:42:24 - 00:42:36",
        "text": "我Crew在做的事情就是,我怎么能够让用户在我们的系统上搭建属于自己的Agent,而且这个Agent是具有self-improvement,self-healing的能力,能够去understand你的workflow。"
      },
      {
        "id": "asr_segment_0293",
        "start_ms": 2557560,
        "end_ms": 2574180,
        "time_range": "00:42:37 - 00:42:54",
        "text": "举个例子,你是在做一个广告的campaign,你每个周可能都要放一个广告,那通常来说你可以用其他的general agent每个周出去做一个这样的事情,但在Crew上你的使用的方法是你create一个属于自己的Agent,比如说这就叫做campaign agent,"
      },
      {
        "id": "asr_segment_0294",
        "start_ms": 2574360,
        "end_ms": 2585280,
        "time_range": "00:42:54 - 00:43:05",
        "text": "我们会在背后做很多harness,保证你的这个campaign agent能够持续地提升他的performance,能够降低他的cost,在这个过程中为你产生更多的产出。"
      },
      {
        "id": "asr_segment_0295",
        "start_ms": 2585680,
        "end_ms": 2598920,
        "time_range": "00:43:05 - 00:43:18",
        "text": "所以你们对标的场景跟你们主要的客户是谁,就是你是对标大企业里面的工作流程自动化的,还是专业的,类似于创业者,或者个人独角兽,类似于这样子的,还是普通的大众?"
      },
      {
        "id": "asr_segment_0296",
        "start_ms": 2599220,
        "end_ms": 2609140,
        "time_range": "00:43:19 - 00:43:29",
        "text": "其实它都会有,但是我们真正的目标来讲还是那些所谓的SMB,还有企业端的那些中小企业的场景,因为这个可能是最早去adopt AI的这个人群。"
      },
      {
        "id": "asr_segment_0297",
        "start_ms": 2609540,
        "end_ms": 2610480,
        "time_range": "00:43:29 - 00:43:30",
        "text": "SMB是什么?"
      },
      {
        "id": "asr_segment_0298",
        "start_ms": 2610900,
        "end_ms": 2616100,
        "time_range": "00:43:30 - 00:43:36",
        "text": "SM就是sm to medium business,就是那些中小型的可能就是30个人以内的团队。"
      },
      {
        "id": "asr_segment_0299",
        "start_ms": 2616340,
        "end_ms": 2629640,
        "time_range": "00:43:36 - 00:43:49",
        "text": "跟你们公司现在非常像的这些团队,然后他们完全开始把自己的工作方式转移成以AI为主导的工作方式,这种是科技公司多,还是说传统公司它也可以做这个转型?"
      },
      {
        "id": "asr_segment_0300",
        "start_ms": 2630180,
        "end_ms": 2637200,
        "time_range": "00:43:50 - 00:43:57",
        "text": "不管你是科技公司还是传统公司,都能做这样的转型,对,因为它核心的难点其实并不是一定是在于取决于你的人数和规模。"
      },
      {
        "id": "asr_segment_0301",
        "start_ms": 2637480,
        "end_ms": 2645400,
        "time_range": "00:43:57 - 00:44:05",
        "text": "大的企业为什么它难?是因为越大的企业它会有越来越多的一些合规的问题,还有很多的一些人上面的因素,会导致它的整个过程会非常艰难。"
      },
      {
        "id": "asr_segment_0302",
        "start_ms": 2645760,
        "end_ms": 2656160,
        "time_range": "00:44:05 - 00:44:16",
        "text": "但是你一家公司如果没有太多的所谓的合规,还有包括传统的一些数据库,还有传统一些lexia的这些东西的话,那其实你就是第一批最容易去做这个转型的公司。"
      },
      {
        "id": "asr_segment_0303",
        "start_ms": 2656520,
        "end_ms": 2660820,
        "time_range": "00:44:16 - 00:44:20",
        "text": "所以我们target就是这样的一批公司,是我们核心的这个目标群体嘛。"
      },
      {
        "id": "asr_segment_0304",
        "start_ms": 2661160,
        "end_ms": 2666940,
        "time_range": "00:44:21 - 00:44:26",
        "text": "一个公司想要做这样的转型,是不是他们的创始人也得有一个核心信念,就是相信AI?"
      },
      {
        "id": "asr_segment_0305",
        "start_ms": 2667280,
        "end_ms": 2672260,
        "time_range": "00:44:27 - 00:44:32",
        "text": "对,这个是,但是我觉得更多还是他们得搞清楚,就是说这个转型最后代表的是什么?"
      },
      {
        "id": "asr_segment_0306",
        "start_ms": 2672300,
        "end_ms": 2682260,
        "time_range": "00:44:32 - 00:44:42",
        "text": "我举个最简单的例子,其实在二三年刚大木星出来的时候,很多的SaaS公司它想的都是,我怎么把AI做成一个功能,集成到我的产品里面。"
      },
      {
        "id": "asr_segment_0307",
        "start_ms": 2682660,
        "end_ms": 2690380,
        "time_range": "00:44:42 - 00:44:50",
        "text": "这个本质来讲是没有搞清楚,如果你要做这样的功能,有没有可能你原来的产品的架构就是不支持把这些最新的AI的能力给集成进来的?"
      },
      {
        "id": "asr_segment_0308",
        "start_ms": 2690620,
        "end_ms": 2695460,
        "time_range": "00:44:50 - 00:44:55",
        "text": "因为你的数据库可能也不符合要求,你的交互可能也不是未来的一个方式。"
      },
      {
        "id": "asr_segment_0309",
        "start_ms": 2695580,
        "end_ms": 2703380,
        "time_range": "00:44:55 - 00:45:03",
        "text": "那所以说你可能需要去做的事情是整体的产品的重构,这个结果如果是你接受不了的话,那可能你也很难做这个转型。"
      },
      {
        "id": "asr_segment_0310",
        "start_ms": 2703800,
        "end_ms": 2713940,
        "time_range": "00:45:03 - 00:45:13",
        "text": "对,所以你们现在在推广这个概念的过程中,因为现在AI发展的也很快,我觉得很多的企业主,包括中小企业,他们是非常愿意去拥抱AI的。"
      },
      {
        "id": "asr_segment_0311",
        "start_ms": 2714040,
        "end_ms": 2721180,
        "time_range": "00:45:14 - 00:45:21",
        "text": "但是我觉得你们整个推行的概念又过于超前,所以你们自己觉得市场对你们的反馈是怎么样的?"
      },
      {
        "id": "asr_segment_0312",
        "start_ms": 2721600,
        "end_ms": 2730260,
        "time_range": "00:45:21 - 00:45:30",
        "text": "其实从我们现在用户上面的反馈来讲,我觉得并不是说我们的概念很超前,而是这也是为什么我们从组织上的变革是我们自己在做的事情。"
      },
      {
        "id": "asr_segment_0313",
        "start_ms": 2730400,
        "end_ms": 2738500,
        "time_range": "00:45:30 - 00:45:38",
        "text": "我们并没有说我们所有的客户跟我们一样去做组织上的改变,而更多是我们把Harness这套系统变成我们的产品,能够让我们的用户先体验起来。"
      },
      {
        "id": "asr_segment_0314",
        "start_ms": 2738500,
        "end_ms": 2741900,
        "time_range": "00:45:38 - 00:45:41",
        "text": "然后在这个过程里面,他在慢慢去思考组织怎么去改变。"
      },
      {
        "id": "asr_segment_0315",
        "start_ms": 2742180,
        "end_ms": 2752800,
        "time_range": "00:45:42 - 00:45:52",
        "text": "我觉得Harness还有一个核心,就是说我对某一个领域非常了解,所以我才能给他做各种的更精确的系统上的限定条件。"
      },
      {
        "id": "asr_segment_0316",
        "start_ms": 2753260,
        "end_ms": 2762740,
        "time_range": "00:45:53 - 00:46:02",
        "text": "假设你说你对代码领域非常了解,我觉得很权威,但我觉得很少有人说我可以是每一个领域的专家,我懂每一个领域。"
      },
      {
        "id": "asr_segment_0317",
        "start_ms": 2763060,
        "end_ms": 2764480,
        "time_range": "00:46:03 - 00:46:04",
        "text": "那这个挑战怎么解决呢?"
      },
      {
        "id": "asr_segment_0318",
        "start_ms": 2764720,
        "end_ms": 2772120,
        "time_range": "00:46:04 - 00:46:12",
        "text": "之前的话你在create一个自己的agent,比如说NewHarmers,或者OpenClaw,或者CallCode,你是需要对代码有一定理解的。"
      },
      {
        "id": "asr_segment_0319",
        "start_ms": 2772180,
        "end_ms": 2773140,
        "time_range": "00:46:12 - 00:46:13",
        "text": "你才能做这件事情。"
      },
      {
        "id": "asr_segment_0320",
        "start_ms": 2773640,
        "end_ms": 2778060,
        "time_range": "00:46:13 - 00:46:18",
        "text": "因为这涉及到很多infrastructure安全性的问题,包括你的tooling怎么接进来。"
      },
      {
        "id": "asr_segment_0321",
        "start_ms": 2778480,
        "end_ms": 2786400,
        "time_range": "00:46:18 - 00:46:26",
        "text": "但是对于比如说Kreo来说,我们提供一个cloud端的service,你作为一个普通的使用者,你是不需要有很多架构的理解。"
      },
      {
        "id": "asr_segment_0322",
        "start_ms": 2786480,
        "end_ms": 2793520,
        "time_range": "00:46:26 - 00:46:33",
        "text": "因为我们把这个架构已经提供给用户了,用户对自己需要完成的任务需要有一个深入的理解。"
      },
      {
        "id": "asr_segment_0323",
        "start_ms": 2793800,
        "end_ms": 2804300,
        "time_range": "00:46:33 - 00:46:44",
        "text": "但是在这个过程之中,包括怎么接入tooling,怎么去maintain这个agent能够长时间的工作,怎么能够保证安全性,是我们为大家提供的这样的一个service。"
      },
      {
        "id": "asr_segment_0324",
        "start_ms": 2804980,
        "end_ms": 2816140,
        "time_range": "00:46:44 - 00:46:56",
        "text": "对,就现在因为我们还是在利用AI的很早期的阶段,当然就是有很多的创业公司都在讨论,就是我们可能要在某一个垂直场景上会非常了解,然后我们才能说我们这块harness做得很好。"
      },
      {
        "id": "asr_segment_0325",
        "start_ms": 2816280,
        "end_ms": 2823120,
        "time_range": "00:46:56 - 00:47:03",
        "text": "但核心实在就是说,因为我们自己的Kreo这家公司,我们也想成为第一批所谓的AI first公司嘛。"
      },
      {
        "id": "asr_segment_0326",
        "start_ms": 2823600,
        "end_ms": 2829380,
        "time_range": "00:47:03 - 00:47:09",
        "text": "那所谓在组织结构调整之后,其实我们是有非常多的基础工作需要被agent化的。"
      },
      {
        "id": "asr_segment_0327",
        "start_ms": 2829660,
        "end_ms": 2835740,
        "time_range": "00:47:09 - 00:47:15",
        "text": "那在这些基础的工作上,首先它可能也并不会涉及到非常多的非常垂直专业的场景。"
      },
      {
        "id": "asr_segment_0328",
        "start_ms": 2835740,
        "end_ms": 2839940,
        "time_range": "00:47:15 - 00:47:19",
        "text": "比如说刚刚Kirk说一些所谓市场调研这个事情,其实很多的人都需要去做。"
      },
      {
        "id": "asr_segment_0329",
        "start_ms": 2840300,
        "end_ms": 2845020,
        "time_range": "00:47:20 - 00:47:25",
        "text": "但是有些人agent利用的好,他这个系统build的好的话,那他自己人需要做的事情就会很少。"
      },
      {
        "id": "asr_segment_0330",
        "start_ms": 2845340,
        "end_ms": 2849260,
        "time_range": "00:47:25 - 00:47:29",
        "text": "但是如果你的系统build的不够好的话,那你人需要做的事情就更多。"
      },
      {
        "id": "asr_segment_0331",
        "start_ms": 2849580,
        "end_ms": 2854140,
        "time_range": "00:47:29 - 00:47:34",
        "text": "其实我们的概念,真正我觉得超前的地方,或者说市场现在没有准备好的地方是在于,"
      },
      {
        "id": "asr_segment_0332",
        "start_ms": 2854460,
        "end_ms": 2859880,
        "time_range": "00:47:34 - 00:47:39",
        "text": "如果你真的想把AI用在你的生产的各个环节上面,首先你的组织结构是要先去变化的。"
      },
      {
        "id": "asr_segment_0333",
        "start_ms": 2860260,
        "end_ms": 2865040,
        "time_range": "00:47:40 - 00:47:45",
        "text": "那组织结构变化之后,你需要有一个系统去保障这个组织能够稳定的运行。"
      },
      {
        "id": "asr_segment_0334",
        "start_ms": 2865340,
        "end_ms": 2867540,
        "time_range": "00:47:45 - 00:47:47",
        "text": "这个就是我们现在build这个harness这套东西。"
      },
      {
        "id": "asr_segment_0335",
        "start_ms": 2867900,
        "end_ms": 2871660,
        "time_range": "00:47:47 - 00:47:51",
        "text": "可不可以讲一下你们的组织结构是如何发生变化的?"
      },
      {
        "id": "asr_segment_0336",
        "start_ms": 2871920,
        "end_ms": 2874340,
        "time_range": "00:47:51 - 00:47:54",
        "text": "比如说以前传统的组织结构是怎么样?"
      },
      {
        "id": "asr_segment_0337",
        "start_ms": 2874400,
        "end_ms": 2875920,
        "time_range": "00:47:54 - 00:47:55",
        "text": "然后现在你们是怎么样?"
      },
      {
        "id": "asr_segment_0338",
        "start_ms": 2876040,
        "end_ms": 2880000,
        "time_range": "00:47:56 - 00:48:00",
        "text": "我觉得刚刚过程中我们举了很多的案例,但是我们还是想知道一个whole picture。"
      },
      {
        "id": "asr_segment_0339",
        "start_ms": 2880360,
        "end_ms": 2884540,
        "time_range": "00:48:00 - 00:48:04",
        "text": "对,整个组织结构的变化,我觉得这里面是很多角色的变化。"
      },
      {
        "id": "asr_segment_0340",
        "start_ms": 2884900,
        "end_ms": 2889280,
        "time_range": "00:48:04 - 00:48:09",
        "text": "首先一,如果你要真的做改造,你需要做第一个点,其实信任上的变化。"
      },
      {
        "id": "asr_segment_0341",
        "start_ms": 2889600,
        "end_ms": 2894220,
        "time_range": "00:48:09 - 00:48:14",
        "text": "就原来你组织信任是人嘛,那人本身是这个组织最核心的那一环。"
      },
      {
        "id": "asr_segment_0342",
        "start_ms": 2894500,
        "end_ms": 2901060,
        "time_range": "00:48:14 - 00:48:21",
        "text": "但现在当你把AI拿进来之后,其实你要先解决第一个问题就是你能不能信任你的AI做决策或去执行任务。"
      },
      {
        "id": "asr_segment_0343",
        "start_ms": 2901400,
        "end_ms": 2905280,
        "time_range": "00:48:21 - 00:48:25",
        "text": "这个信任其实就跟为什么我们要去build一个harness的系统是一个道理。"
      },
      {
        "id": "asr_segment_0344",
        "start_ms": 2905280,
        "end_ms": 2915020,
        "time_range": "00:48:25 - 00:48:35",
        "text": "就是我们得有很多的就所谓的guerals还有机制去保障AI做的所有的工作,不管它做决策也好,还做planning也好,还做最后的execution执行也好。"
      },
      {
        "id": "asr_segment_0345",
        "start_ms": 2915280,
        "end_ms": 2917960,
        "time_range": "00:48:35 - 00:48:37",
        "text": "那最后它的这个东西是能够被人去信任的。"
      },
      {
        "id": "asr_segment_0346",
        "start_ms": 2918260,
        "end_ms": 2921160,
        "time_range": "00:48:38 - 00:48:41",
        "text": "那接下来就是你所有的组织结构里面的具体的位置的变化。"
      },
      {
        "id": "asr_segment_0347",
        "start_ms": 2921480,
        "end_ms": 2931040,
        "time_range": "00:48:41 - 00:48:51",
        "text": "产品经理这个角色在我们公司其实是不能说它不存在,而是它被拆解到了每一个工程师和像Peter这样子的做工程管理的人身上。"
      },
      {
        "id": "asr_segment_0348",
        "start_ms": 2931080,
        "end_ms": 2935460,
        "time_range": "00:48:51 - 00:48:55",
        "text": "而不是专门在有一个单独的角色去做这个所谓的产品的这个事情。"
      },
      {
        "id": "asr_segment_0349",
        "start_ms": 2935760,
        "end_ms": 2942560,
        "time_range": "00:48:55 - 00:49:02",
        "text": "因为产品经理这个岗位我并不觉得它不重要,而是在于它在大多数公司,它其实是矛盾最集中的那个点。"
      },
      {
        "id": "asr_segment_0350",
        "start_ms": 2942940,
        "end_ms": 2946380,
        "time_range": "00:49:02 - 00:49:06",
        "text": "因为产品经理同时要跟市场人沟通,也要跟开发人沟通。"
      },
      {
        "id": "asr_segment_0351",
        "start_ms": 2946740,
        "end_ms": 2951100,
        "time_range": "00:49:06 - 00:49:11",
        "text": "所有的对齐的成本很多时候也都会发生在那个产品经理的那个角色上面。"
      },
      {
        "id": "asr_segment_0352",
        "start_ms": 2951520,
        "end_ms": 2956080,
        "time_range": "00:49:11 - 00:49:16",
        "text": "但当你把这个角色给拿掉之后,你会发现对齐的成本反而有时候可能会更低。"
      },
      {
        "id": "asr_segment_0353",
        "start_ms": 2956540,
        "end_ms": 2962560,
        "time_range": "00:49:16 - 00:49:22",
        "text": "这个前提也是在于你需要有一套机制能保证在没有产品经理的情况下团队之间还能互相信任。"
      },
      {
        "id": "asr_segment_0354",
        "start_ms": 2962560,
        "end_ms": 2968700,
        "time_range": "00:49:22 - 00:49:28",
        "text": "就决策的信任成本没有因为没有这个角色而变得更高,而是说没有这个角色之后它会变得更低嘛。"
      },
      {
        "id": "asr_segment_0355",
        "start_ms": 2969040,
        "end_ms": 2974540,
        "time_range": "00:49:29 - 00:49:34",
        "text": "那所以说这个其实就是我们在组织上可能跟传统这些所谓的软件开发公司会不太一样的地方。"
      },
      {
        "id": "asr_segment_0356",
        "start_ms": 2975200,
        "end_ms": 2978800,
        "time_range": "00:49:35 - 00:49:38",
        "text": "产品经理这个角色,你觉得现在还有价值吗?"
      },
      {
        "id": "asr_segment_0357",
        "start_ms": 2978880,
        "end_ms": 2984220,
        "time_range": "00:49:38 - 00:49:44",
        "text": "或者说重新招一个类似于产品经理角色的人,你觉得他需要有什么样的新技能?"
      },
      {
        "id": "asr_segment_0358",
        "start_ms": 2984580,
        "end_ms": 3000000,
        "time_range": "00:49:44 - 00:50:00",
        "text": "这个问题应该是这样问,未来需不需要产品经理,他一定需要的,但是未来需要的是一种新的形态的产品经理,因为你的开发成本在降低,所以产品经理更多的首先它本身的背景也会发生变化,他做的事情可能他"
      },
      {
        "id": "asr_segment_0359",
        "start_ms": 3000000,
        "end_ms": 3029080,
        "time_range": "00:50:00 - 00:50:29",
        "text": "原来是一个工程师之后工程师也可以成为产品经理的角色。那更多的人可能能够成为这种所谓的新型的产品经理。或说未来还有种可能就是说他的职位的很多的权利会分散在开发团队的各个的人的身上。因为如果说你的每一个开发团队成员在AI的帮助下都能够更好地去有产品观念的话,那其实你本质来讲有没有这个职位也不太重要。因为原来产品经理我觉得它更多解决的是对齐的成本,还有包括如何帮助公司去降低这个所谓的开发成本。"
      },
      {
        "id": "asr_segment_0360",
        "start_ms": 3029180,
        "end_ms": 3046620,
        "time_range": "00:50:29 - 00:50:46",
        "text": "对,我可不可以这样理解,就是现在相当于工程师Peter的团队,他们某种程度上扮演了产品经理的角色,但是反过来一个好的产品经理他其实是对市场是非常有想法的,然后对产品也是非常有想法的,加上现在开发的成本是非常低的。"
      },
      {
        "id": "asr_segment_0361",
        "start_ms": 3046620,
        "end_ms": 3058360,
        "time_range": "00:50:46 - 00:50:58",
        "text": "他可能也很容易就把他的一个想法通过AI的执行能力很快变成了一个好的产品,他甚至不需要工程团队了。所以说其实这两种角色"
      },
      {
        "id": "asr_segment_0362",
        "start_ms": 3058360,
        "end_ms": 3067700,
        "time_range": "00:50:58 - 00:51:07",
        "text": "他某种程度上他在融合,在变成一种角色,所以这个角色到底是一个技术的团队来做,还是一个产品的团队来做,其实不重要。"
      },
      {
        "id": "asr_segment_0363",
        "start_ms": 3067860,
        "end_ms": 3070360,
        "time_range": "00:51:07 - 00:51:10",
        "text": "因为都是AI在主导,想法更重要。"
      },
      {
        "id": "asr_segment_0364",
        "start_ms": 3070720,
        "end_ms": 3087220,
        "time_range": "00:51:10 - 00:51:27",
        "text": "对,因为会有人会觉得就说,未来产品经理可能会变得更重要,因为就像您刚刚提到就说,如果产品经理也能写代码,那他可能自己就能build的一个产品,但是一样会有人会觉得就说,那产品经理因为他没有很多的技术的背景,那他就算能build的一个产品,那这个产品到底能不能被商业化?"
      },
      {
        "id": "asr_segment_0365",
        "start_ms": 3087600,
        "end_ms": 3097100,
        "time_range": "00:51:27 - 00:51:37",
        "text": "我们要打个问号,如果这个产品真的要需要被商业化的时候,那可能我们还是需要有工程师,真的能够帮这个产品经理去把这个产品给构建得更加,能够商业化。"
      },
      {
        "id": "asr_segment_0366",
        "start_ms": 3097440,
        "end_ms": 3104000,
        "time_range": "00:51:37 - 00:51:44",
        "text": "未来这个职位本身,他可能不是说是一个人,而是一个团队整体扮演这个产品经理的角色。"
      },
      {
        "id": "asr_segment_0367",
        "start_ms": 3104440,
        "end_ms": 3108060,
        "time_range": "00:51:44 - 00:51:48",
        "text": "这个角色本身,他会被组织化掉,而不是被个人化掉。"
      },
      {
        "id": "asr_segment_0368",
        "start_ms": 3108280,
        "end_ms": 3115140,
        "time_range": "00:51:48 - 00:51:55",
        "text": "在传统软件时代下,有很多个人英雄主义就说,因为某一个产品经理或一个灵魂人物,导致最后这个产品特别受欢迎。"
      },
      {
        "id": "asr_segment_0369",
        "start_ms": 3115400,
        "end_ms": 3120080,
        "time_range": "00:51:55 - 00:52:00",
        "text": "但未来可能是一个组织可能做了一个很好的产品,被这个市场接受。"
      },
      {
        "id": "asr_segment_0370",
        "start_ms": 3120160,
        "end_ms": 3130640,
        "time_range": "00:52:00 - 00:52:10",
        "text": "对,我觉得有一个非常明显的trend,就是复合心人才或者比较general的人,他在AI环境之下可以thrive的更好一些。"
      },
      {
        "id": "asr_segment_0371",
        "start_ms": 3131020,
        "end_ms": 3140320,
        "time_range": "00:52:11 - 00:52:20",
        "text": "不管是说一个工程师他有产品的sense和marketing的sense,还是说一个产品经理他具有implementation的能力,都会非常的重要。"
      },
      {
        "id": "asr_segment_0372",
        "start_ms": 3140660,
        "end_ms": 3147900,
        "time_range": "00:52:20 - 00:52:27",
        "text": "刚才一直在谈产品经理,其实有另外一些rule像designer,不管是前段的designer还是UXdesigner。"
      },
      {
        "id": "asr_segment_0373",
        "start_ms": 3148200,
        "end_ms": 3154340,
        "time_range": "00:52:28 - 00:52:34",
        "text": "如果你问我未来的产品之中什么是最重要的,可能这两个rule会变得非常的重要。"
      },
      {
        "id": "asr_segment_0374",
        "start_ms": 3154720,
        "end_ms": 3166960,
        "time_range": "00:52:34 - 00:52:46",
        "text": "但是我们在讨论这两个rule不是说传统的,不具备coding或者implementation能力的designer,而是具有能够把自己的想法implement到的产品之中的这些UX和UIdesigner。"
      },
      {
        "id": "asr_segment_0375",
        "start_ms": 3167260,
        "end_ms": 3172880,
        "time_range": "00:52:47 - 00:52:52",
        "text": "这些人会变得非常的重要,包括产品经理同样的事情,未来的产品需要有产品的sense。"
      },
      {
        "id": "asr_segment_0376",
        "start_ms": 3172880,
        "end_ms": 3181280,
        "time_range": "00:52:52 - 00:53:01",
        "text": "那这些产品的sense来源于谁其实并不重要,但是有一点是非常重要的,这个人必须就有implementation的能力。"
      },
      {
        "id": "asr_segment_0377",
        "start_ms": 3181640,
        "end_ms": 3186140,
        "time_range": "00:53:01 - 00:53:06",
        "text": "他能把他的idea直接在一到两个小时之内的时间就带到产品之中。"
      },
      {
        "id": "asr_segment_0378",
        "start_ms": 3186500,
        "end_ms": 3196300,
        "time_range": "00:53:06 - 00:53:16",
        "text": "如果你需要把你的idea传递给另外一个人或者另外一个engineer,那你交流或alignment的成本就远大于你implementation的成品。"
      },
      {
        "id": "asr_segment_0379",
        "start_ms": 3196300,
        "end_ms": 3201200,
        "time_range": "00:53:16 - 00:53:21",
        "text": "在整个的这个AI的工作环境之下就变得不是那么的efficient。"
      },
      {
        "id": "asr_segment_0380",
        "start_ms": 3201880,
        "end_ms": 3204300,
        "time_range": "00:53:21 - 00:53:24",
        "text": "Peter,你有一篇文章,我印象很深啊。"
      },
      {
        "id": "asr_segment_0381",
        "start_ms": 3204660,
        "end_ms": 3216360,
        "time_range": "00:53:24 - 00:53:36",
        "text": "你说其实在你真的做这一系列的组织架构的变化的过程中,你意识到初级的工程师是比资深的工程师更能适应AI的这个环境的。"
      },
      {
        "id": "asr_segment_0382",
        "start_ms": 3216720,
        "end_ms": 3238560,
        "time_range": "00:53:36 - 00:53:58",
        "text": "因为初级的engineer不管说他的tech debt或者他的思想的速度通常来说比较小,他能够接受他的expand,他的scope,就是他不仅是作为一个engineer,包括他要融入到一些产品的设计之中,包括产品,他的feature deploy之后,他还需要做一些analysis,他根据analysis能够做出他这样的一个判断。"
      },
      {
        "id": "asr_segment_0383",
        "start_ms": 3238620,
        "end_ms": 3268000,
        "time_range": "00:53:58 - 00:54:28",
        "text": "但通常来讲比较senior的engineering他比较specialized,比如说你是一个做infer的人,或者你是一个做后端的人,你可能在传统的工作环境之中你不care你的code shape之后发生的事情,但是在AI这个环境之下,你的engineer的scope就需要比之前扩大的很多,就不只是在我把这个代码写完之后就结束了,而是在于我代码写之前,我怎么能够把自己的judgment加进去,代码ship之后,"
      },
      {
        "id": "asr_segment_0384",
        "start_ms": 3268080,
        "end_ms": 3276900,
        "time_range": "00:54:28 - 00:54:36",
        "text": "怎么能够判断它的impact,整个的这个过程是非常重要的。通常来讲,junior engineer的话,能够更好地接受这样的一种工作状态。"
      },
      {
        "id": "asr_segment_0385",
        "start_ms": 3277360,
        "end_ms": 3288560,
        "time_range": "00:54:37 - 00:54:48",
        "text": "那比如说你跟一个资深工程师说,除了负责前面,就是你代码已经交完了的这个过程,你还要负责后面的这个过程,他们是不能理解跟马上去转变这个思想的。"
      },
      {
        "id": "asr_segment_0386",
        "start_ms": 3288900,
        "end_ms": 3298060,
        "time_range": "00:54:48 - 00:54:58",
        "text": "通常来讲,需要align这个mindset的成本要高很多,其实作为一个senior的engineer,或者作为一个专业领域,"
      },
      {
        "id": "asr_segment_0387",
        "start_ms": 3298080,
        "end_ms": 3306460,
        "time_range": "00:54:58 - 00:55:06",
        "text": "不管你是做info的人,还是frontend的人,还是backend的人,在过去的软件开发过程之中,你的knowledge是非常valuable的。"
      },
      {
        "id": "asr_segment_0388",
        "start_ms": 3306900,
        "end_ms": 3317920,
        "time_range": "00:55:06 - 00:55:17",
        "text": "因为你能够知道在开发这个系统之中,怎么样写最简洁的代码,怎么样设计最好的architecture,你可能需要两三个月的时间去完成这样一个事情。"
      },
      {
        "id": "asr_segment_0389",
        "start_ms": 3318280,
        "end_ms": 3329900,
        "time_range": "00:55:18 - 00:55:29",
        "text": "但是在AI这个环境之下,因为AI coding在现阶段它已经很强了,以后会变得更强,所以它会让你本身的specialty变得越来越低,所以很多人可能接受不了这样一种状态。"
      },
      {
        "id": "asr_segment_0390",
        "start_ms": 3329900,
        "end_ms": 3336680,
        "time_range": "00:55:29 - 00:55:36",
        "text": "就是它本身可能花了十年二十年时间,学到的这样一些知识变得可能在未来并不那么重要。"
      },
      {
        "id": "asr_segment_0391",
        "start_ms": 3337480,
        "end_ms": 3342500,
        "time_range": "00:55:37 - 00:55:42",
        "text": "所以你们现在更倾向于招哪一类的人,我拿工程师来举一个例子吧。"
      },
      {
        "id": "asr_segment_0392",
        "start_ms": 3342820,
        "end_ms": 3349300,
        "time_range": "00:55:42 - 00:55:49",
        "text": "比如说初级的人,他可能面临的问题是,他在代码领域基础没有那么的扎实了。"
      },
      {
        "id": "asr_segment_0393",
        "start_ms": 3349680,
        "end_ms": 3358480,
        "time_range": "00:55:49 - 00:55:58",
        "text": "因为大家现在都已经用AI写代码了嘛,可能你真的,比如说这个AI系统它突然关机了,他们自己可能就写不了了。"
      },
      {
        "id": "asr_segment_0394",
        "start_ms": 3358540,
        "end_ms": 3367240,
        "time_range": "00:55:58 - 00:56:07",
        "text": "而且如果你的代码基础不扎实的话,就是你在判断它出问题的时候,你的专业知识也会稍微的差那么一点点。"
      },
      {
        "id": "asr_segment_0395",
        "start_ms": 3367580,
        "end_ms": 3380200,
        "time_range": "00:56:07 - 00:56:20",
        "text": "但是呢,对于很多资深的工程师来说,他们依然非常的稀缺,就是因为他们还是有非常扎实的工程的基础,但是他们可能在转变跟适应AI思维上,他并没有年轻人那么快。"
      },
      {
        "id": "asr_segment_0396",
        "start_ms": 3380580,
        "end_ms": 3394840,
        "time_range": "00:56:20 - 00:56:34",
        "text": "我文章中虽然提到,要转变一个资深的工程师的难度要比一个相对来说Junior的难度大,但是从value上来讲,一个资深的工程师的value现在是不能被取代的。"
      },
      {
        "id": "asr_segment_0397",
        "start_ms": 3395180,
        "end_ms": 3406500,
        "time_range": "00:56:35 - 00:56:46",
        "text": "所以怎么能够找到一个资深的工程师,他还能够embrace AI的mindset,而且他能够具有一个产品的sense,他能够还知道一些marketing的knowledge。"
      },
      {
        "id": "asr_segment_0398",
        "start_ms": 3406660,
        "end_ms": 3409960,
        "time_range": "00:56:46 - 00:56:49",
        "text": "这个人虽然很难找,但是对于公司来说是非常value的。"
      },
      {
        "id": "asr_segment_0399",
        "start_ms": 3410360,
        "end_ms": 3418360,
        "time_range": "00:56:50 - 00:56:58",
        "text": "好处是在于,之前我们可能需要很多这样的人在没有AI的情况之下,但是现在来后,我们可能只需要一到两个人就可以了。"
      },
      {
        "id": "asr_segment_0400",
        "start_ms": 3418680,
        "end_ms": 3420000,
        "time_range": "00:56:58 - 00:57:00",
        "text": "很多是多少,十个?"
      },
      {
        "id": "asr_segment_0401",
        "start_ms": 3420240,
        "end_ms": 3424860,
        "time_range": "00:57:00 - 00:57:04",
        "text": "我觉得十倍或者五十倍以上的人在没有AI辅助的情况之下。"
      },
      {
        "id": "asr_segment_0402",
        "start_ms": 3425740,
        "end_ms": 3433380,
        "time_range": "00:57:05 - 00:57:13",
        "text": "但我觉得这样的人是不是也还比较好找,是因为我最近看见硅谷的趋势是,所有人都在开始用AI,"
      },
      {
        "id": "asr_segment_0403",
        "start_ms": 3433380,
        "end_ms": 3442120,
        "time_range": "00:57:13 - 00:57:22",
        "text": "然后所有人都在开始比这个AI生成代码的数量,大家也在很积极地去适应这个新时代新环境。"
      },
      {
        "id": "asr_segment_0404",
        "start_ms": 3442460,
        "end_ms": 3450980,
        "time_range": "00:57:22 - 00:57:30",
        "text": "对,我们可能通常会发现有很多人是这样子的一个心态嘛,但是有这样的心态跟在工作的时候愿意去相信AI,"
      },
      {
        "id": "asr_segment_0405",
        "start_ms": 3451180,
        "end_ms": 3459760,
        "time_range": "00:57:31 - 00:57:39",
        "text": "然后真的把所谓的harness这些系统去build起来,就是我相信它跟我愿意花时间去构建一个系统,能帮助我更好地用AI去工作,"
      },
      {
        "id": "asr_segment_0406",
        "start_ms": 3460080,
        "end_ms": 3461220,
        "time_range": "00:57:40 - 00:57:41",
        "text": "这是完全两码事情。"
      },
      {
        "id": "asr_segment_0407",
        "start_ms": 3461420,
        "end_ms": 3467120,
        "time_range": "00:57:41 - 00:57:47",
        "text": "就是很多人会发现,他愿意拥抱AI只是在于他愿意用AI的工具去给自己去提升效率,"
      },
      {
        "id": "asr_segment_0408",
        "start_ms": 3467460,
        "end_ms": 3473740,
        "time_range": "00:57:47 - 00:57:53",
        "text": "但他并不愿意说我去构建一个系统,真的能让未来我的工作完全由AI来驱动。"
      },
      {
        "id": "asr_segment_0409",
        "start_ms": 3474200,
        "end_ms": 3478340,
        "time_range": "00:57:54 - 00:57:58",
        "text": "我在里面可能扮演角色都可能发生变化了,那这是两种完全不一样的心态。"
      },
      {
        "id": "asr_segment_0410",
        "start_ms": 3478780,
        "end_ms": 3484700,
        "time_range": "00:57:58 - 00:58:04",
        "text": "其实后面那种更激进那个心态的工程师也好,或者说做marketing的人也好,或者说做任何事情的人也好,"
      },
      {
        "id": "asr_segment_0411",
        "start_ms": 3484780,
        "end_ms": 3489380,
        "time_range": "00:58:04 - 00:58:09",
        "text": "相对来讲在现在这个阶段这个思想还是相对来讲比较超前的,这样的人还是少数,"
      },
      {
        "id": "asr_segment_0412",
        "start_ms": 3489480,
        "end_ms": 3493540,
        "time_range": "00:58:09 - 00:58:13",
        "text": "现在更多人更接受还在于我愿意去尝试用个AI工具或拥抱AI的能力,"
      },
      {
        "id": "asr_segment_0413",
        "start_ms": 3493680,
        "end_ms": 3498100,
        "time_range": "00:58:13 - 00:58:18",
        "text": "但是我还没有到真的我希望做到AI first这个角度来讲,这样的人是比较少的。"
      },
      {
        "id": "asr_segment_0414",
        "start_ms": 3498160,
        "end_ms": 3504060,
        "time_range": "00:58:18 - 00:58:24",
        "text": "对,另外从一个角度上来讲,我认识的很多朋友其实他本身的能力很强,"
      },
      {
        "id": "asr_segment_0415",
        "start_ms": 3504200,
        "end_ms": 3509940,
        "time_range": "00:58:24 - 00:58:29",
        "text": "他有很强的架构能力,然后他源于永远AI,但通常很多这样的人他会自己出来创业。"
      },
      {
        "id": "asr_segment_0416",
        "start_ms": 3510320,
        "end_ms": 3513860,
        "time_range": "00:58:30 - 00:58:33",
        "text": "对于一个startup,你想hire这种人,其实现在难度还是比较大的。"
      },
      {
        "id": "asr_segment_0417",
        "start_ms": 3514380,
        "end_ms": 3517440,
        "time_range": "00:58:34 - 00:58:37",
        "text": "是,Peter你是从什么时候开始相信AI的?"
      },
      {
        "id": "asr_segment_0418",
        "start_ms": 3517520,
        "end_ms": 3521860,
        "time_range": "00:58:37 - 00:58:41",
        "text": "就是我觉得凯今天给我特别大的一个震撼,就是相信AI这四个字。"
      },
      {
        "id": "asr_segment_0419",
        "start_ms": 3522160,
        "end_ms": 3526720,
        "time_range": "00:58:42 - 00:58:46",
        "text": "如果你问我的话,我其实从一开始刚毕业的时候,我就是在做AI。"
      },
      {
        "id": "asr_segment_0420",
        "start_ms": 3526860,
        "end_ms": 3528340,
        "time_range": "00:58:46 - 00:58:48",
        "text": "你是哪一年毕业的?"
      },
      {
        "id": "asr_segment_0421",
        "start_ms": 3528740,
        "end_ms": 3532440,
        "time_range": "00:58:48 - 00:58:52",
        "text": "我是哪一年毕业的?"
      },
      {
        "id": "asr_segment_0422",
        "start_ms": 3533080,
        "end_ms": 3534720,
        "time_range": "00:58:53 - 00:58:54",
        "text": "我应该是18年吧。"
      },
      {
        "id": "asr_segment_0423",
        "start_ms": 3535180,
        "end_ms": 3537300,
        "time_range": "00:58:55 - 00:58:57",
        "text": "你毕业我们肯定不会记得那么清楚。"
      },
      {
        "id": "asr_segment_0424",
        "start_ms": 3537300,
        "end_ms": 3541340,
        "time_range": "00:58:57 - 00:59:01",
        "text": "我可能是,具体我记不清了,但是可能是十年之前的事情,"
      },
      {
        "id": "asr_segment_0425",
        "start_ms": 3541460,
        "end_ms": 3545040,
        "time_range": "00:59:01 - 00:59:05",
        "text": "我第一个在苹果做的工作就是在做AI方面的工作,"
      },
      {
        "id": "asr_segment_0426",
        "start_ms": 3545400,
        "end_ms": 3547620,
        "time_range": "00:59:05 - 00:59:07",
        "text": "而且也就是和语言模型相关的。"
      },
      {
        "id": "asr_segment_0427",
        "start_ms": 3547860,
        "end_ms": 3552020,
        "time_range": "00:59:07 - 00:59:12",
        "text": "所以我肯定是从一开始就相信AI能够改变这个世界的。"
      },
      {
        "id": "asr_segment_0428",
        "start_ms": 3552320,
        "end_ms": 3553860,
        "time_range": "00:59:12 - 00:59:13",
        "text": "对,那个时候大模型还没出来,"
      },
      {
        "id": "asr_segment_0429",
        "start_ms": 3554060,
        "end_ms": 3556140,
        "time_range": "00:59:14 - 00:59:16",
        "text": "然后那个时候我们在提到AI的时候,"
      },
      {
        "id": "asr_segment_0430",
        "start_ms": 3556220,
        "end_ms": 3559600,
        "time_range": "00:59:16 - 00:59:19",
        "text": "跟今天我们提到AI的时候是完全不一样的。"
      },
      {
        "id": "asr_segment_0431",
        "start_ms": 3559700,
        "end_ms": 3563040,
        "time_range": "00:59:19 - 00:59:23",
        "text": "包括我觉得那个时候AI给人的这个思想上的冲击,"
      },
      {
        "id": "asr_segment_0432",
        "start_ms": 3563200,
        "end_ms": 3565420,
        "time_range": "00:59:23 - 00:59:25",
        "text": "说我们是不是要把工作彻底地交给AI,"
      },
      {
        "id": "asr_segment_0433",
        "start_ms": 3565520,
        "end_ms": 3566700,
        "time_range": "00:59:25 - 00:59:26",
        "text": "跟今天也是不一样的。"
      },
      {
        "id": "asr_segment_0434",
        "start_ms": 3566700,
        "end_ms": 3568300,
        "time_range": "00:59:26 - 00:59:28",
        "text": "对,但是那个时候虽然没有大模型,"
      },
      {
        "id": "asr_segment_0435",
        "start_ms": 3568400,
        "end_ms": 3570140,
        "time_range": "00:59:28 - 00:59:30",
        "text": "但是是非常重要的一篇paper,"
      },
      {
        "id": "asr_segment_0436",
        "start_ms": 3570300,
        "end_ms": 3571700,
        "time_range": "00:59:30 - 00:59:31",
        "text": "就是Attention is all you need,"
      },
      {
        "id": "asr_segment_0437",
        "start_ms": 3571940,
        "end_ms": 3575700,
        "time_range": "00:59:31 - 00:59:35",
        "text": "包括之前Burt的出现正好是我刚开始工作的时候。"
      },
      {
        "id": "asr_segment_0438",
        "start_ms": 3575700,
        "end_ms": 3579080,
        "time_range": "00:59:35 - 00:59:39",
        "text": "在那个时候我就意识到了pre-training的重要性,"
      },
      {
        "id": "asr_segment_0439",
        "start_ms": 3579460,
        "end_ms": 3584140,
        "time_range": "00:59:39 - 00:59:44",
        "text": "包括对于我当时在苹果做的一些traffic prediction的一些工作,"
      },
      {
        "id": "asr_segment_0440",
        "start_ms": 3584280,
        "end_ms": 3586100,
        "time_range": "00:59:44 - 00:59:46",
        "text": "我就已经开始利用pre-training,"
      },
      {
        "id": "asr_segment_0441",
        "start_ms": 3586320,
        "end_ms": 3589620,
        "time_range": "00:59:46 - 00:59:49",
        "text": "因为之前的pre-training只是在文字上的pre-training嘛,"
      },
      {
        "id": "asr_segment_0442",
        "start_ms": 3589740,
        "end_ms": 3591760,
        "time_range": "00:59:49 - 00:59:51",
        "text": "我会在traffic signal上的pre-training,"
      },
      {
        "id": "asr_segment_0443",
        "start_ms": 3592120,
        "end_ms": 3595280,
        "time_range": "00:59:52 - 00:59:55",
        "text": "而是同样利用了类似的concept来做这样的事情。"
      },
      {
        "id": "asr_segment_0444",
        "start_ms": 3595740,
        "end_ms": 3597960,
        "time_range": "00:59:55 - 00:59:57",
        "text": "所以可能是因为你的工作经历的关系,"
      },
      {
        "id": "asr_segment_0445",
        "start_ms": 3598080,
        "end_ms": 3600000,
        "time_range": "00:59:58 - 01:00:00",
        "text": "你一出来,甚至是你还没有出来,"
      },
      {
        "id": "asr_segment_0446",
        "start_ms": 3600000,
        "end_ms": 3602820,
        "time_range": "01:00:00 - 01:00:02",
        "text": "就你一直都觉得AI它是比人强的。"
      },
      {
        "id": "asr_segment_0447",
        "start_ms": 3603140,
        "end_ms": 3629220,
        "time_range": "01:00:03 - 01:00:29",
        "text": "我没有说AI会一直比人强,哪怕是现在这个阶段,AI也不能够取代人来做任何的事情,但是AI in the future或者在现在这样一个阶段,我AI已经能够主导很多事情,包括在架构的过程之中,AI是很强,但是你让AI系统能够运转起来,还是需要人去进行架构的。"
      },
      {
        "id": "asr_segment_0448",
        "start_ms": 3630000,
        "end_ms": 3644220,
        "time_range": "01:00:30 - 01:00:44",
        "text": "对,我们刚刚其实有聊未来要招什么样的人啊,你觉得现在我们说AI为主力干活,AI可以迭代产品,所有的东西都是动态的,大家觉得未来人它最核心的能力是什么呢?"
      },
      {
        "id": "asr_segment_0449",
        "start_ms": 3644680,
        "end_ms": 3653420,
        "time_range": "01:00:44 - 01:00:53",
        "text": "我觉得最大人需要的能力就是系统架构的能力,从以前implement的feature变成怎么架构这个AI系统和maintain这个AI系统。"
      },
      {
        "id": "asr_segment_0450",
        "start_ms": 3653420,
        "end_ms": 3654840,
        "time_range": "01:00:53 - 01:00:54",
        "text": "这是工程师的角度。"
      },
      {
        "id": "asr_segment_0451",
        "start_ms": 3655240,
        "end_ms": 3666860,
        "time_range": "01:00:55 - 01:01:06",
        "text": "对,不管是工程师还是marketing的角度,那你做go to market怎么搭建一套能够自主运行的agent的marketing系统也是核心的过程,而不是说只是单纯的产生一个marketing content。"
      },
      {
        "id": "asr_segment_0452",
        "start_ms": 3667860,
        "end_ms": 3677720,
        "time_range": "01:01:07 - 01:01:17",
        "text": "这个话就是说人的价值如果从真的很长远来看,就跟我们技术发展整个过程一样,确定技术发展方向永远是人的需求和这个社会的需求嘛。"
      },
      {
        "id": "asr_segment_0453",
        "start_ms": 3678040,
        "end_ms": 3686760,
        "time_range": "01:01:18 - 01:01:26",
        "text": "只要人这个物种还存在,它的价值是不太会变化的,它定义的是需求的方向和技术迭代的方向,因为它永远要为这个物种去服务嘛。"
      },
      {
        "id": "asr_segment_0454",
        "start_ms": 3687120,
        "end_ms": 3693980,
        "time_range": "01:01:27 - 01:01:33",
        "text": "如果没有人在这个上面的价值的话,那就代表AI是自己在发展,那它自己就是一个物种了变成,对,这个是一个哲学问题嘛。"
      },
      {
        "id": "asr_segment_0455",
        "start_ms": 3694300,
        "end_ms": 3699460,
        "time_range": "01:01:34 - 01:01:39",
        "text": "那至于我定义了需求,那我一样就会需要去看最后的结果,是不是我想要的。"
      },
      {
        "id": "asr_segment_0456",
        "start_ms": 3699740,
        "end_ms": 3707460,
        "time_range": "01:01:39 - 01:01:47",
        "text": "那所以在未来系统里面,人呢还有一个很重要的价值是我review最后的结果,去看这个结果是不是真的符合我们的利益或符合我们的要求。"
      },
      {
        "id": "asr_segment_0457",
        "start_ms": 3707680,
        "end_ms": 3717660,
        "time_range": "01:01:47 - 01:01:57",
        "text": "人在需求的定义和最终的结果的审核上的价值是没有办法被取代的,除非说人作为这个物种本身的重要性已经不存在了,那这个是另外一回事情。"
      },
      {
        "id": "asr_segment_0458",
        "start_ms": 3717860,
        "end_ms": 3725560,
        "time_range": "01:01:57 - 01:02:05",
        "text": "对,我看最近应该是deep mind的,他们已经开始设立哲学家的岗位了,职位就叫哲学家。"
      },
      {
        "id": "asr_segment_0459",
        "start_ms": 3725860,
        "end_ms": 3736880,
        "time_range": "01:02:05 - 01:02:16",
        "text": "对,当然这里面有非常多的问题,包括如果我们真的把AI引进到agent真的能替代人工作,那还有一个道德的问题是在于,那agent和其他的agent也好,其他人之间也好也会有沟通。"
      },
      {
        "id": "asr_segment_0460",
        "start_ms": 3737300,
        "end_ms": 3747460,
        "time_range": "01:02:17 - 01:02:27",
        "text": "那他沟通的这些内容到底,比如说我作为另外一个人能不能去看,那是不是侵犯他的隐私呢?这里面其实会有非常多道德的问题,他都是跟未来组织这些关系都相关的嘛。"
      },
      {
        "id": "asr_segment_0461",
        "start_ms": 3747800,
        "end_ms": 3748480,
        "time_range": "01:02:27 - 01:02:28",
        "text": "好,Clerk。"
      },
      {
        "id": "asr_segment_0462",
        "start_ms": 3749000,
        "end_ms": 3758260,
        "time_range": "01:02:29 - 01:02:38",
        "text": "我觉得其实刚刚凯讲的挺好的,因为我自己觉得人未来的价值就是判断任何事情是否还有价值,对于价值的定义可能就是人最大的价值。"
      },
      {
        "id": "asr_segment_0463",
        "start_ms": 3758340,
        "end_ms": 3766520,
        "time_range": "01:02:38 - 01:02:46",
        "text": "价值的定义本身延伸出来的东西就是我们怎么样定义自己的需求是什么,当我们知道自己想要什么的时候才能判断这件事情是否有价值。"
      },
      {
        "id": "asr_segment_0464",
        "start_ms": 3766920,
        "end_ms": 3768240,
        "time_range": "01:02:46 - 01:02:48",
        "text": "我觉得这个就是人的价值。"
      },
      {
        "id": "asr_segment_0465",
        "start_ms": 3768940,
        "end_ms": 3777320,
        "time_range": "01:02:48 - 01:02:57",
        "text": "对,你们对未来整体是更悲观还是更乐观?我是说完全抛开企业,就是作为人来说。"
      },
      {
        "id": "asr_segment_0466",
        "start_ms": 3777880,
        "end_ms": 3795200,
        "time_range": "01:02:57 - 01:03:15",
        "text": "我自己还是相对乐观的吧,其实很多时候大家探讨就是人他为什么快乐,我自己现在工作还挺快乐,就是因为我虽然在工作中跟AI的配合会导致我的工作的内容和工作的程度会比之前要强很多。"
      },
      {
        "id": "asr_segment_0467",
        "start_ms": 3795200,
        "end_ms": 3805480,
        "time_range": "01:03:15 - 01:03:25",
        "text": "但是当我不工作的时候,我在享受自然爬山也好,还是去做一些户外运动的时候也好,我可能会更加的放松。"
      },
      {
        "id": "asr_segment_0468",
        "start_ms": 3805920,
        "end_ms": 3817820,
        "time_range": "01:03:25 - 01:03:37",
        "text": "所以我觉得相对来说是比较乐观,就是可能AI给我们带来的价值就是,比如说我们原来就经常说你work hard, play hard,他可能可以反而更好地帮我去做工作和生活上的切割。"
      },
      {
        "id": "asr_segment_0469",
        "start_ms": 3818480,
        "end_ms": 3825460,
        "time_range": "01:03:38 - 01:03:45",
        "text": "我们做创业的话,我们肯定是乐观的,如果悲观的话就大家今天也不会出来创业了嘛,对未来肯定还是相对来讲比较乐观的。"
      },
      {
        "id": "asr_segment_0470",
        "start_ms": 3825720,
        "end_ms": 3832140,
        "time_range": "01:03:45 - 01:03:52",
        "text": "但是就像我们刚刚聊的就是因为就跟上一次工业革命一样,就是当时有很多的纺织工人也好,车夫也好,可能都被取代掉了。"
      },
      {
        "id": "asr_segment_0471",
        "start_ms": 3832180,
        "end_ms": 3846320,
        "time_range": "01:03:52 - 01:04:06",
        "text": "但是随着那个阶段过去之后,人会找到新的方向去实现更大的一个自我价值嘛,那所以说未来的话它一定是一个更好的世界,只不过这个世界是不是跟现在大家所定义的这个幸福一样,那可能是不一样的。"
      },
      {
        "id": "asr_segment_0472",
        "start_ms": 3846320,
        "end_ms": 3849520,
        "time_range": "01:04:06 - 01:04:09",
        "text": "这可能是可能未来会有的一个比较大的一个变化嘛。"
      },
      {
        "id": "asr_segment_0473",
        "start_ms": 3849880,
        "end_ms": 3862420,
        "time_range": "01:04:09 - 01:04:22",
        "text": "对,我觉得我还是非常谨慎的乐观的,因为我觉得在这个变革的过程之中会有很多痛苦和很多noise,但是这个变革的结果,我还是believe in它是一个好的结果。"
      },
      {
        "id": "asr_segment_0474",
        "start_ms": 3862880,
        "end_ms": 3869440,
        "time_range": "01:04:22 - 01:04:29",
        "text": "就是人能够更多的有不管说自由的时间,还是能够发挥出自己更大的价值,在AI的辅助之下。"
      },
      {
        "id": "asr_segment_0475",
        "start_ms": 3869900,
        "end_ms": 3871340,
        "time_range": "01:04:29 - 01:04:31",
        "text": "好的,好的,好,谢谢各位。"
      },
      {
        "id": "asr_segment_0476",
        "start_ms": 3874160,
        "end_ms": 3884480,
        "time_range": "01:04:34 - 01:04:44",
        "text": "好的,感谢三位的分享,我们今天聊了很多有意思的内容啊,比如说产品与工程的连接在消失,SaaS产品它本身也在重构。"
      },
      {
        "id": "asr_segment_0477",
        "start_ms": 3884960,
        "end_ms": 3896400,
        "time_range": "01:04:44 - 01:04:56",
        "text": "那我想三位的观点可能对很多的普通听众来说它是有一点点超前的,但是呢我觉得这种一线亲历者的视角恰好是大模型时代最稀缺的内容之一。"
      },
      {
        "id": "asr_segment_0478",
        "start_ms": 3896920,
        "end_ms": 3901940,
        "time_range": "01:04:56 - 01:05:01",
        "text": "大家对未来公司的组织形态有什么样的思考,欢迎给我们写评论,写留言。"
      },
      {
        "id": "asr_segment_0479",
        "start_ms": 3902420,
        "end_ms": 3906620,
        "time_range": "01:05:02 - 01:05:06",
        "text": "那我们未来呢,还会从更多的角度持续地关注这个话题。"
      },
      {
        "id": "asr_segment_0480",
        "start_ms": 3907200,
        "end_ms": 3914800,
        "time_range": "01:05:07 - 01:05:14",
        "text": "如果大家喜欢我们的播客,可以在小宇宙苹果播客,YouTube,Bilibili,小红书和视频号上收听关注我们。"
      },
      {
        "id": "asr_segment_0481",
        "start_ms": 3914940,
        "end_ms": 3916860,
        "time_range": "01:05:14 - 01:05:16",
        "text": "我是红军,感谢大家的收听。"
      }
    ]
  }
} as const;

export type EpisodeTranscriptKey = keyof typeof episodeTranscripts;
